<template>
    <div class="editor-boq-wrapper">
    <!--Upload File Section-->
    <Card v-if="canViewRKTK && (!Is_Additional || CanIputScope) && !DoneMC" class="upload-card">
        <template #content>
            <div class="upload-container">
                <div class="upload-header">
                    <h4 class="upload-title">Upload Document BoQ</h4>
                </div>
                <div class="upload-body">
                    <div class="file-input-wrapper">
                        <input 
                            type="file" 
                            ref="fileInput"
                            accept=".xlsx,.xls"
                            @change="onFileSelect"
                            :disabled="formMode != $FORM_MODE_CREATE && formMode != $FORM_MODE_EDIT"
                            id="boqFileInput"
                        />
                        <label for="boqFileInput" class="file-input-label">
                            <i class="pi pi-file-excel"></i>
                            <span class="file-label-text">{{ selectedFile ? selectedFile.name : 'Pilih File Excel' }}</span>
                        </label>
                    </div>
                    <Button 
                        label="Upload"
                        icon="pi pi-upload"
                        @click="uploadFile"
                        class="p-button-sm upload-btn"
                        :disabled="!selectedFile || (formMode != $FORM_MODE_CREATE && formMode != $FORM_MODE_EDIT)"
                        :loading="isUploading"
                    />
                </div>
                <div v-if="uploadMessage" class="upload-message">
                    <small :class="'message-' + uploadMessageType">
                        <i :class="'pi ' + (uploadMessageType === 'success' ? 'pi-check-circle' : uploadMessageType === 'error' ? 'pi-times-circle' : 'pi-info-circle')"></i>
                        {{ uploadMessage }}
                    </small>
                </div>
            </div>
        </template>
    </Card>

    <!--BoQ Main-->
    <Card class="boq-card">
        <template #header>
            <div class="card-header-title">
                <span class="text-900 font-bold">BoQ Main SPO</span>
            </div>
        </template>
        <template #content>
            <div class="p-inputtext-sm p-fluid">
                <div class="grid">
                    <div class="col-12">
                        <div class="table-wrapper-fixed-header">
                            <DataTable
                                :loading ="!boqCombined"
                                :value="boqCombined"
                                responsiveLayout="scroll"
                                class="p-datatable-sm editable-cells-table table-fixed-header"
                                style="width: 100%; white-space: nowrap;"
                                editMode="cell"
                            >

                            <!-- ColumnGroup Header -->
                            <ColumnGroup type="header">
                            <Row>
                                <Column :header="$t('action')" :rowspan="2" />
                                <Column  :rowspan="2" />
                                <Column :header="$t('type')" :rowspan="2" />
                                <Column :header="$t('no')" :rowspan="2" />
                                <Column :header="$t('scope')" :rowspan="2" />
                                <Column :header="$t('unit')" :rowspan="2" />

                                <Column :header="$t('initial_contract')" :colspan="canViewRKTK ? 5 : 2" />
                                <Column header="Updated (Latest)" :colspan="2" :hidden="!canViewRKTK" />
                                <Column :header="$t('MC0')" :colspan="2" />
                                <Column :header="$t('MC_Between')" :colspan="2" />
                                <Column :header="$t('MC100')" :colspan="2" />
                                <Column :header="$t('RKTK_MC0')" :colspan="2" :hidden="!canViewRKTK" />
                                <Column :header="$t('RKTK_MC_Between')" :colspan="2" :hidden="!canViewRKTK" />
                                <Column :header="$t('RKTK_MC100')" :colspan="2" :hidden="!canViewRKTK" />
                                <Column :header="$t('Contract_MC0')" :colspan="canViewRKTK ? 2 : 1" />
                                <Column :header="$t('Contract_MC_Between')" :colspan="canViewRKTK ? 2 : 1" />
                                <Column :header="$t('Contract_MC100')" :colspan="canViewRKTK ? 2 : 1" />
                                <Column :header="$t('Contract_Adjust')" :colspan="2" :hidden="!canViewRKTK" />
                            </Row>

                            <Row>
                                <!-- initial_contract -->
                                <Column :header="$t('Volume')" />
                                <Column :header="$t('material_price')" :hidden="!canViewRKTK" />
                                <Column :header="$t('labour_price')" :hidden="!canViewRKTK" />
                                <Column :header="$t('Amount')" :hidden="!canViewRKTK" />
                                <Column :header="$t('percent_bobot')" />
                                <!-- Updated (Latest) -->
                                <Column :header="$t('material_price')" :hidden="!canViewRKTK" />
                                <Column :header="$t('labour_price')" :hidden="!canViewRKTK" />
                                <!-- MC0 -->
                                <Column :header="$t('Deviasi')" />
                                <Column :header="$t('Volume')" />
                                <!-- MC_Between -->
                                <Column :header="$t('Deviasi')" />
                                <Column :header="$t('Volume')" />
                                <!-- MC100 -->
                                <Column :header="$t('Deviasi')" />
                                <Column :header="$t('Volume')" />
                                <!-- RKTK_MC0 -->
                                <Column :header="$t('Deviasi')" :hidden="!canViewRKTK" />
                                <Column :header="$t('Amount')" :hidden="!canViewRKTK" />
                                <!-- RKTK_MC_Between -->
                                <Column :header="$t('Deviasi')" :hidden="!canViewRKTK" />
                                <Column :header="$t('Amount')" :hidden="!canViewRKTK" />
                                <!-- RKTK_MC100 -->
                                <Column :header="$t('Deviasi')" :hidden="!canViewRKTK" />
                                <Column :header="$t('Amount')" :hidden="!canViewRKTK" />
                                <!-- Contract_MC0 -->
                                <Column :header="$t('Volume')" />
                                <Column :header="$t('Amount')" :hidden="!canViewRKTK" />
                                <!-- Contract_MC_Between -->
                                <Column :header="$t('Volume')" />
                                <Column :header="$t('Amount')" :hidden="!canViewRKTK" />
                                <!-- Contract_MC100 -->
                                <Column :header="$t('Volume')" />
                                <Column :header="$t('Amount')" :hidden="!canViewRKTK" />
                                <!-- Contract_Adjust -->
                                <Column :header="$t('Volume')" :hidden="!canViewRKTK" />
                                <Column :header="$t('Amount')" :hidden="!canViewRKTK" />
                            </Row>
                            </ColumnGroup>

                            <!-- Body Columns -->
                            <Column field="Action" style="width: 80px; min-width: 80px;">
                            <template #body="slotProps">
                                <div v-if="(formMode == $FORM_MODE_CREATE || formMode == $FORM_MODE_EDIT) && slotProps.data.isTypeHeader && slotProps.data.Type == $BOQ_TYPE.MAIN_SCOPE && !DoneMC && (!Is_Additional || CanIputScope)">
                                <Button
                                    icon="pi pi-plus"
                                    class="p-button-sm p-button-primary"
                                    @click="addBoQ(slotProps.data.Type)"
                                />
                                </div>
                                <div v-else-if="slotProps.data.Type == $BOQ_TYPE.MAIN_SCOPE && !DoneMC && (!Is_Additional || CanIputScope)">
                                <Button
                                    icon="pi pi-minus"
                                    class="p-button-sm p-button-danger"
                                    @click="deleteBoQ(slotProps.data, slotProps.data.Type)"
                                    :disabled="formMode != $FORM_MODE_CREATE && formMode != $FORM_MODE_EDIT"
                                    v-show="slotProps.data.mode != 'Delete'"
                                />
                                </div>
                            </template>
                            </Column>

                            <Column field="Type" style="width: 100px; min-width: 100px;">
                                <template #body="slotProps">
                                    <div v-if="slotProps.data.isTypeHeader && !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow">
                                        <b>{{ slotProps.data.Type }}</b>
                                    </div>
                                </template>
                            </Column>

                            <Column field="Section_Type" style="width: 80px; min-width: 80px;">
                                <template #body="slotProps">
                                    <div v-if="!slotProps.data.isTypeHeader && !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" class="p-fluid">
                                        <CustomSelect
                                            v-model="slotProps.data.Section_Type" 
                                            :url="$API_URL + 'list/lookup'"
                                            :params="{ group: $LOOKUP_GROUP.TYPE_BOQ }" 
                                            :minLength="0" 
                                            :filter="true"
                                            @change="onTypeBoQChange(slotProps.data)"
                                            :disabled="(formMode != $FORM_MODE_CREATE && formMode != $FORM_MODE_EDIT) || DoneMC || slotProps.data.Type != $BOQ_TYPE.MAIN_SCOPE || !CanIputScope"
                                        />
                                    </div>
                                </template>
                            </Column>

                            <Column field="No_BoQ" style="width: 150px; min-width: 150px;">
                                <template #body="slotProps">
                                    <InputText
                                    v-if="!slotProps.data.isTypeHeader && !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                    v-model="slotProps.data.No_BoQ"
                                    @change="onCellEditCompleteBoQ(slotProps.data)"
                                    :disabled="(formMode != $FORM_MODE_CREATE && formMode != $FORM_MODE_EDIT) || slotProps.data.Type != $BOQ_TYPE.MAIN_SCOPE || !CanIputScope"
                                    />
                                </template>
                            </Column>

                            <Column field="Scope" style="width: 350px; min-width: 350px;">
                                <template #body="slotProps">
                                    <Textarea 
                                    v-if="!slotProps.data.isTypeHeader && !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                    v-model="slotProps.data.Scope"
                                    @change="onCellEditCompleteBoQ(slotProps.data)"
                                    :disabled="(fmode != $FORM_MODE_CREATE && formMode != $FORM_MODE_EDIT) || slotProps.data.Type != $BOQ_TYPE.MAIN_SCOPE || !CanIputScope"
                                    />
                                </template>
                            </Column>

                            <Column field="Unit" style="width: 100px; min-width: 100px;">
                                <template #body="slotProps">
                                    <InputText
                                    v-if="!slotProps.data.isTypeHeader && !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                    v-model="slotProps.data.Unit"
                                     @change="onCellEditCompleteBoQ(slotProps.data)"
                                    :disabled="
                                        (formMode != $FORM_MODE_CREATE && formMode != $FORM_MODE_EDIT)
                                        || slotProps.data.Type != $BOQ_TYPE.MAIN_SCOPE
                                        || !CanIputScope
                                        || String(
                                            slotProps.data?.Section_Type?.Value
                                            ?? slotProps.data?.Section_Type
                                            ?? ''
                                        ).toLowerCase() === 'section'
                                    "
                                    />
                                </template>
                            </Column>

                            <!-- Initial Contract -->
                            <Column field="Initial_Contract_Volume" style="width: 150px; min-width: 150px;">
                            <template #body="slotProps">
                                <InputNumber v-if="!slotProps.data.isTypeHeader && !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.Initial_Contract_Volume" :maxFractionDigits="6" :minFractionDigits="0" :min="-9999999999"
                                     :disabled="
                                        (formMode != $FORM_MODE_CREATE && formMode != $FORM_MODE_EDIT)
                                        || slotProps.data.Type != $BOQ_TYPE.MAIN_SCOPE
                                        || !CanIputScope
                                        || DoneAddendum
                                        || String(
                                            slotProps.data?.Section_Type?.Value
                                            ?? slotProps.data?.Section_Type
                                            ?? ''
                                        ).toLowerCase() === 'section'
                                    "
                                    
                                    @input="onPriceOrVolumeChange($event, slotProps.data, 'Initial_Contract_Volume')" 
                                    @blur="onPriceOrVolumeChange($event, slotProps.data, 'Initial_Contract_Volume'); onCellEditCompleteBoQ(slotProps.data);"
                                />
                                <span v-else-if="slotProps.data.isTotalRow" class="font-bold text-right w-full block">
                                    {{ slotProps.data.Description_Total }}
                                </span>
                            </template>
                            </Column>
                            <!-- Initial Material Price -->
                            <Column field="Initial_Material_Price" style="width: 150px; min-width: 150px;" :hidden="!canViewRKTK">
                                <template #body="slotProps">
                                    <InputNumber
                                    v-if="!slotProps.data.isTypeHeader && !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                    :modelValue="initialMaterialPrice(slotProps.data)"
                                    disabled
                                    v-lock-input="true"
                                    :maxFractionDigits="4"
                                    :minFractionDigits="0"
                                    />
                                </template>
                            </Column>

                            <Column field="Initial_Labour_Price" style="width: 150px; min-width: 150px;" :hidden="!canViewRKTK">
                                <template #body="slotProps">
                                    <InputNumber
                                    v-if="!slotProps.data.isTypeHeader && !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                    :modelValue="initialLabourPrice(slotProps.data)"
                                    disabled
                                    v-lock-input="true"
                                    :maxFractionDigits="4"
                                    :minFractionDigits="0"
                                    />
                                </template>
                            </Column>
                            
                            <Column field="Initial_Contract_Amount" style="width: 150px; min-width: 150px;" :hidden="!canViewRKTK">
                                <template #body="slotProps">
                                    <InputNumber v-if="!slotProps.data.isTypeHeader && slotProps.data.isTotalRow"
                                        v-model="slotProps.data.Initial_Contract_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                        
                                        :disabled="true"
                                        v-lock-input="true"
                                    />
                                    <InputNumber v-else-if="!slotProps.data.isTypeHeader && !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                        v-model="slotProps.data.Initial_Contract_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                   
                                        :disabled="true"
                                        v-lock-input="true"
                                    />

                                </template>
                            </Column>
                            <!-- % Bobot -->
                            <Column field="Percent_Bobot" style="width: 150px; min-width: 150px;">
                                <template #body="slotProps">
                                    <InputNumber
                                    v-if="!slotProps.data.isTypeHeader && !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                    :modelValue="percentBobot(slotProps.data, boqCombined)"
                                    disabled
                                    v-lock-input="true"
                                    suffix=" %"
                                    :maxFractionDigits="2"
                                    :minFractionDigits="2"
                                    />
                                </template>
                            </Column>
                            <!-- Updated (Latest) -->

                            <Column field="Material_Price" style="width: 150px; min-width: 150px;" :hidden="!canViewRKTK">
                                <template #body="slotProps">
                                    <InputNumber
                                    v-if="!slotProps.data.isTypeHeader && !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                    v-model="slotProps.data.Material_Price"
                                    :disabled="
                                        (formMode != $FORM_MODE_CREATE && formMode != $FORM_MODE_EDIT)
                                        || String(
                                            slotProps.data?.Section_Type?.Value
                                            ?? slotProps.data?.Section_Type
                                            ?? ''
                                        ).toLowerCase() === 'section'
                                    "
                                    :maxFractionDigits="4"
                                    :minFractionDigits="0"
                                      @input="onPriceOrVolumeChange($event, slotProps.data, 'Material_Price')" 
                                      @blur="onPriceOrVolumeChange($event, slotProps.data, 'Material_Price'); onCellEditCompleteBoQ(slotProps.data);"
                                    />
                                </template>
                            </Column>

                            <Column field="Labour_Price" style="width: 150px; min-width: 150px;" :hidden="!canViewRKTK">
                                <template #body="slotProps">
                                    <InputNumber
                                    v-if="!slotProps.data.isTypeHeader && !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                    v-model="slotProps.data.Labour_Price"
                                    :disabled="
                                        (formMode != $FORM_MODE_CREATE && formMode != $FORM_MODE_EDIT)
                                        || String(
                                            slotProps.data?.Section_Type?.Value
                                            ?? slotProps.data?.Section_Type
                                            ?? ''
                                        ).toLowerCase() === 'section'
                                    "
                                    :maxFractionDigits="4"
                                    :minFractionDigits="0"
                                    @input="onPriceOrVolumeChange($event, slotProps.data, 'Labour_Price')" 
                                    @blur="onPriceOrVolumeChange($event, slotProps.data, 'Labour_Price'); onCellEditCompleteBoQ(slotProps.data);"
                                    />
                                </template>
                            </Column>
                            
                            <!-- MC0 -->
                            <Column field="MC0_Deviation" style="width: 150px; min-width: 150px;">
                            <template #body="slotProps">
                                <InputNumber v-if="!slotProps.data.isTypeHeader && !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                v-model="slotProps.data.MC0_Deviation" :maxFractionDigits="6" :minFractionDigits="0"
                                :disabled="true"
                                v-lock-input="true"
                                />
                            </template>
                            </Column>
                            <Column field="MC0_Volume" style="width: 150px; min-width: 150px;">
                            <template #body="slotProps">
                                <InputNumber v-if="!slotProps.data.isTypeHeader && !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                v-model="slotProps.data.MC0_Volume" :maxFractionDigits="6" :minFractionDigits="0"
                                :disabled="true"
                                v-lock-input="true"
                                />
                            </template>
                            </Column>

                            <!-- MC_Between -->
                            <Column field="MCBetween_Deviation" style="width: 150px; min-width: 150px;">
                            <template #body="slotProps">
                                <InputNumber v-if="!slotProps.data.isTypeHeader && !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                v-model="slotProps.data.MCBetween_Deviation" :maxFractionDigits="6" :minFractionDigits="0"
                                :disabled="true"
                                v-lock-input="true"
                                />
                            </template>
                            </Column>
                            <Column field="MCBetween_Volume" style="width: 150px; min-width: 150px;">
                            <template #body="slotProps">
                                <InputNumber v-if="!slotProps.data.isTypeHeader && !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                v-model="slotProps.data.MCBetween_Volume" :maxFractionDigits="6" :minFractionDigits="0"
                                :disabled="true"
                                v-lock-input="true"
                                />
                            </template>
                            </Column>

                            <!-- MC100 -->
                            <Column field="MC100_Deviation" style="width: 150px; min-width: 150px;">
                            <template #body="slotProps">
                                <InputNumber v-if="!slotProps.data.isTypeHeader && !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                v-model="slotProps.data.MC100_Deviation" :maxFractionDigits="6" :minFractionDigits="0"
                                :disabled="true"
                                v-lock-input="true"
                                />
                            </template>
                            </Column>
                            <Column field="MC100_Volume" style="width: 150px; min-width: 150px;">
                            <template #body="slotProps">
                                <InputNumber v-if="!slotProps.data.isTypeHeader && !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                v-model="slotProps.data.MC100_Volume" :maxFractionDigits="6" :minFractionDigits="0"
                                :disabled="true"
                                v-lock-input="true"
                                />
                            </template>
                            </Column>

                            <!-- RKTK_MC0 -->
                            <Column field="RKTK_MC0_Deviation" style="width: 150px; min-width: 150px;" :hidden="!canViewRKTK">
                            <template #body="slotProps">
                                <InputNumber v-if="!slotProps.data.isTypeHeader && !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                v-model="slotProps.data.RKTK_MC0_Deviation" :maxFractionDigits="6" :minFractionDigits="0"
                                :disabled="true"
                                v-lock-input="true"
                                />
                                <span v-else-if="slotProps.data.isTotalRow" class="font-bold text-right w-full block">
                                    {{ slotProps.data.Description_Total}}
                                </span>
                            </template>
                            </Column>
                            <Column field="RKTK_MC0_Amount" style="width: 150px; min-width: 150px;" :hidden="!canViewRKTK">
                            <template #body="slotProps">
                                <InputNumber v-if="!slotProps.data.isTypeHeader && slotProps.data.isTotalRow" 
                                    v-model="slotProps.data.RKTK_MC0_Amount" :maxFractionDigits="6" :minFractionDigits="0"
                                    :disabled="true"
                                    v-lock-input="true"
                                />
                                <InputNumber v-else-if="!slotProps.data.isTypeHeader && !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.RKTK_MC0_Amount" :maxFractionDigits="6" :minFractionDigits="0"
                                    :disabled="true"
                                    v-lock-input="true"
                                />

                            </template>
                            </Column>

                            <!-- RKTK_MC_Between -->
                            <Column field="RKTK_MCBetween_Deviation" style="width: 150px; min-width: 150px;" :hidden="!canViewRKTK">
                            <template #body="slotProps">
                                <InputNumber v-if="!slotProps.data.isTypeHeader && !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                v-model="slotProps.data.RKTK_MCBetween_Deviation" :maxFractionDigits="4" :minFractionDigits="0"
                                :disabled="true"
                                v-lock-input="true"
                                />
                                <span v-else-if="slotProps.data.isTotalRow" class="font-bold text-right w-full block">
                                    {{ slotProps.data.Description_Total}}
                                </span>
                            </template>
                            </Column>
                            <Column field="RKTK_MCBetween_Amount" style="width: 150px; min-width: 150px;" :hidden="!canViewRKTK">
                            <template #body="slotProps">
                                <InputNumber v-if="!slotProps.data.isTypeHeader && slotProps.data.isTotalRow" 
                                    v-model="slotProps.data.RKTK_MCBetween_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                    :disabled="true"
                                    v-lock-input="true"
                                />
                                <InputNumber v-else-if="!slotProps.data.isTypeHeader && !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.RKTK_MCBetween_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                    :disabled="true"
                                    v-lock-input="true"
                                />
                            </template>
                            </Column>

                            <!-- RKTK_MC100 -->
                            <Column field="RKTK_MC100_Deviation" style="width: 150px; min-width: 150px;" :hidden="!canViewRKTK">
                            <template #body="slotProps">
                                <InputNumber v-if="!slotProps.data.isTypeHeader && !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                v-model="slotProps.data.RKTK_MC100_Deviation" :maxFractionDigits="4" :minFractionDigits="0"
                                :disabled="true"
                                v-lock-input="true"
                                />
                                <span v-else-if="slotProps.data.isTotalRow" class="font-bold text-right w-full block">
                                    {{ slotProps.data.Description_Total}}
                                </span>
                            </template>
                            </Column>
                            <Column field="RKTK_MC100_Amount" style="width: 150px; min-width: 150px;" :hidden="!canViewRKTK">
                            <template #body="slotProps">
                                <InputNumber v-if="!slotProps.data.isTypeHeader && slotProps.data.isTotalRow" 
                                    v-model="slotProps.data.RKTK_MC100_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                    :disabled="true"
                                    v-lock-input="true"
                                />
                                <InputNumber v-else-if="!slotProps.data.isTypeHeader && !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.RKTK_MC100_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                    :disabled="true"
                                    v-lock-input="true"
                                />
                            </template>
                            </Column>


                            <!-- Contract_MC0 -->
                            <Column field="MC0_Contract_Volume" style="width: 150px; min-width: 150px;">
                            <template #body="slotProps">
                                <InputNumber v-if="!slotProps.data.isTypeHeader && !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                v-model="slotProps.data.MC0_Contract_Volume" :maxFractionDigits="6" :minFractionDigits="0"
                                :disabled="true"
                                v-lock-input="true"
                                />
                                <span v-else class="font-bold text-right w-full block">
                                    {{ slotProps.data.Description_Total}}
                                </span>
                            </template>
                            </Column>
                            <Column field="MC0_Contract_Amount" style="width: 150px; min-width: 150px;" :hidden="!canViewRKTK">
                            <template #body="slotProps">
                                <InputNumber v-if="!slotProps.data.isTypeHeader" v-model="slotProps.data.MC0_Contract_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                :disabled="true"
                                v-lock-input="true"
                                />
                            </template>
                            </Column>
                            <!-- Contract_MC_Between -->
                            <Column field="MCBetween_Contract_Volumee" style="width: 150px; min-width: 150px;">
                            <template #body="slotProps">
                                <InputNumber v-if="!slotProps.data.isTypeHeader && !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                v-model="slotProps.data.MCBetween_Contract_Volume" :maxFractionDigits="6" :minFractionDigits="0"
                                :disabled="true"
                                v-lock-input="true"
                                />
                                <span v-else class="font-bold text-right w-full block">
                                    {{ slotProps.data.Description_Total}}
                                </span>
                            </template>
                            </Column>
                            <Column field="MCBetween_Contract_Amount" style="width: 150px; min-width: 150px;" :hidden="!canViewRKTK">
                            <template #body="slotProps">
                                <InputNumber v-if="!slotProps.data.isTypeHeader" v-model="slotProps.data.MCBetween_Contract_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                :disabled="true"
                                v-lock-input="true"
                                />
                            </template>
                            </Column>
                            <!-- Contract_MC100 -->
                            <Column field="MC100_Contract_Volume" style="width: 150px; min-width: 150px;">
                            <template #body="slotProps">
                                <InputNumber v-if="!slotProps.data.isTypeHeader && !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                v-model="slotProps.data.MC100_Contract_Volume" :maxFractionDigits="6" :minFractionDigits="0"
                                :disabled="true"
                                v-lock-input="true"
                                />
                                <span v-else class="font-bold text-right w-full block">
                                    {{ slotProps.data.Description_Total}}
                                </span>
                            </template>
                            </Column>
                            <Column field="MC100_Contract_Amount" style="width: 150px; min-width: 150px;" :hidden="!canViewRKTK">
                            <template #body="slotProps">
                                <InputNumber v-if="!slotProps.data.isTypeHeader" v-model="slotProps.data.MC100_Contract_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                :disabled="true"
                                v-lock-input="true"
                                />
                            </template>
                            </Column>
                            <!-- Contract_Adjust -->
                            <Column field="Temp_Adjust_Contract_Volume" style="width: 150px; min-width: 150px;" :hidden="!canViewRKTK">
                            <template #body="slotProps">
                                <InputNumber v-if="!slotProps.data.isTypeHeader && !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                v-model="slotProps.data.Temp_Adjust_Contract_Volume" :maxFractionDigits="6" :minFractionDigits="0"
                                :disabled="true"
                                v-lock-input="true"
                                />
                                <span v-else-if="slotProps.data.isTotalRow" class="font-bold text-right w-full block">
                                    {{ slotProps.data.Description_Total}}
                                </span>
                            </template>
                            </Column>
                            <Column field="Temp_Adjust_Contract_Amount" style="width: 150px; min-width: 150px;" :hidden="!canViewRKTK">
                            <template #body="slotProps">
                                <InputNumber v-if="!slotProps.data.isTypeHeader && slotProps.data.isTotalRow" 
                                    v-model="slotProps.data.Temp_Adjust_Contract_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                    :disabled="true"
                                    v-lock-input="true"
                                />
                                <InputNumber v-else-if="!slotProps.data.isTypeHeader && !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.Temp_Adjust_Contract_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                    :disabled="true"
                                    v-lock-input="true"
                                />
                            </template>
                            </Column>
                        </DataTable>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </Card>
    <!--BoQ Addendum MC0-->
    <Card class="boq-card">
        <template #header>
            <div class="card-header-title">
                <span class="text-900 font-bold">BoQ SPO Addendum (From MC-0)</span>
            </div>
        </template>
        <template #content>
            <div class="p-inputtext-sm p-fluid">
                <div class="grid">
                    <div class="col-12">
                        <div class="table-wrapper-fixed-header">
                            <DataTable
                                :value="boqAddendum"
                                responsiveLayout="scroll"
                                class="p-datatable-sm editable-cells-table table-fixed-header boq-addendum-table"
                                style="width: 100%; white-space: nowrap;"
                                editMode="cell"
                            >
                            <!-- ColumnGroup Header -->
                            <ColumnGroup type="header">
                                <Row>
                                    <Column :header="$t('type')" :rowspan="2" />
                                    <Column :header="$t('no')" :rowspan="2" />
                                    <Column :header="$t('scope')" :rowspan="2" />
                                    <Column :header="$t('unit')" :rowspan="2" />

                                    <Column :header="$t('initial_contract')" :colspan="canViewRKTK ? 5 : 2" />
                                    <Column header="Updated (Latest)" :colspan="2" :hidden="!canViewRKTK" />
                                    <Column :header="$t('MC0')" :colspan="2" />
                                    <Column :header="$t('MC_Between')" :colspan="2" />
                                    <Column :header="$t('MC100')" :colspan="2" />
                                    <Column :header="$t('RKTK_MC0')" :colspan="2" :hidden="!canViewRKTK" />
                                    <Column :header="$t('RKTK_MC_Between')" :colspan="2" :hidden="!canViewRKTK" />
                                    <Column :header="$t('RKTK_MC100')" :colspan="2" :hidden="!canViewRKTK" />
                                    <Column :header="$t('Contract_MC0')" :colspan="canViewRKTK ? 2 : 1" />
                                    <Column :header="$t('Contract_MC_Between')" :colspan="canViewRKTK ? 2 : 1" />
                                    <Column :header="$t('Contract_MC100')" :colspan="canViewRKTK ? 2 : 1" />
                                    <Column :header="$t('Contract_Adjust')" :colspan="2" :hidden="!canViewRKTK" />
                                </Row>

                                <Row>
                                    <!-- initial_contract -->
                                    <Column :header="$t('Volume')" />
                                    <Column :header="$t('material_price')" :hidden="!canViewRKTK" />
                                    <Column :header="$t('labour_price')" :hidden="!canViewRKTK" />
                                    <Column :header="$t('Amount')" :hidden="!canViewRKTK" />
                                    <Column :header="$t('percent_bobot')" />
                                    <!-- Updated (Latest) -->
                                    <Column :header="$t('material_price')" :hidden="!canViewRKTK" />
                                    <Column :header="$t('labour_price')" :hidden="!canViewRKTK" />
                                    <!-- MC0 -->
                                    <Column :header="$t('Deviasi')" />
                                    <Column :header="$t('Volume')" />
                                    <!-- MC_Between -->
                                    <Column :header="$t('Deviasi')" />
                                    <Column :header="$t('Volume')" />
                                    <!-- MC100 -->
                                    <Column :header="$t('Deviasi')" />
                                    <Column :header="$t('Volume')" />
                                    <!-- RKTK_MC0 -->
                                    <Column :header="$t('Deviasi')" :hidden="!canViewRKTK" />
                                    <Column :header="$t('Amount')" :hidden="!canViewRKTK" />
                                    <!-- RKTK_MC_Between -->
                                    <Column :header="$t('Deviasi')" :hidden="!canViewRKTK" />
                                    <Column :header="$t('Amount')" :hidden="!canViewRKTK" />
                                    <!-- RKTK_MC100 -->
                                    <Column :header="$t('Deviasi')" :hidden="!canViewRKTK" />
                                    <Column :header="$t('Amount')" :hidden="!canViewRKTK" />
                                    <!-- Contract_MC0 -->
                                    <Column :header="$t('Volume')" />
                                    <Column :header="$t('Amount')" :hidden="!canViewRKTK" />
                                    <!-- Contract_MC_Between -->
                                    <Column :header="$t('Volume')" />
                                    <Column :header="$t('Amount')" :hidden="!canViewRKTK" />
                                    <!-- Contract_MC100 -->
                                    <Column :header="$t('Volume')" />
                                    <Column :header="$t('Amount')" :hidden="!canViewRKTK" />
                                    <!-- Contract_Adjust -->
                                    <Column :header="$t('Volume')" :hidden="!canViewRKTK" />
                                    <Column :header="$t('Amount')" :hidden="!canViewRKTK" />
                                </Row>
                            </ColumnGroup>
                                <Column field="Section_Type">
                                    <template #body="slotProps">
                                        <InputText
                                         v-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                        v-model="slotProps.data.Section_Type"
                                        :disabled="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="No_BoQ">
                                    <template #body="slotProps">
                                        <InputText
                                         v-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                        v-model="slotProps.data.No_BoQ"
                                        :disabled="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Scope">
                                    <template #body="slotProps">
                                        <Textarea 
                                        v-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                        v-model="slotProps.data.Scope"
                                        :disabled="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Unit">
                                    <template #body="slotProps">
                                        <InputText
                                        v-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                        v-model="slotProps.data.Unit"
                                        :disabled="true"
                                        />
                                    </template>
                                </Column>

                                <!-- Initial Contract -->
                                <Column field="Initial_Contract_Volume" class="column-min-width">
                                    <template #body="slotProps">
                                        <InputNumber v-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                            v-model="slotProps.data.Initial_Contract_Volume" :maxFractionDigits="6" :minFractionDigits="0" :min="-9999999999"
                                        :disabled="true"
                                        v-lock-input="true"
                                        />
                                        <span v-else-if="slotProps.data.isTotalRow" class="font-bold text-right w-full block">
                                            {{ slotProps.data.Description_Total }}
                                        </span>
                                    </template>
                                </Column>
                                <Column field="Initial_Material_Price" :hidden="!canViewRKTK">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                        :modelValue="initialMaterialPrice(slotProps.data)"
                                         disabled
                                        v-lock-input="true"
                                        :maxFractionDigits="4"
                                        :minFractionDigits="0"
                                        />
                                    </template>
                                </Column>
                                <Column field="Initial_Labour_Price" :hidden="!canViewRKTK">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                        :modelValue="initialLabourPrice(slotProps.data)"
                                        :maxFractionDigits="4"
                                        :minFractionDigits="0"
                                        disabled
                                        v-lock-input="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Initial_Contract_Amount" class="column-min-width" :hidden="!canViewRKTK">
                                    <template #body="slotProps">
                                        <InputNumber v-if=" slotProps.data.isTotalRow"
                                                v-model="slotProps.data.Initial_Contract_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                                :disabled="true"
                                                v-lock-input="true"
                                            />
                                            <InputNumber v-else-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                                v-model="slotProps.data.Initial_Contract_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                                :disabled="true"
                                                v-lock-input="true"
                                            />
                                    </template>
                                </Column>
                                <!-- % Bobot -->
                                <Column field="Percent_Bobot">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                        :modelValue="percentBobotAddendum(slotProps.data)"
                                         disabled
                                        v-lock-input="true"
                                        suffix=" %"
                                        :maxFractionDigits="2"
                                        :minFractionDigits="2"
                                        />
                                    </template>
                                </Column>

                                <!-- Updated (Latest) -->
                                <Column field="Material_Price" :hidden="!canViewRKTK">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                        v-model="slotProps.data.Material_Price"
                                         :disabled="
                                            (formMode != $FORM_MODE_CREATE && formMode != $FORM_MODE_EDIT)
                                            || String(
                                                slotProps.data?.Section_Type?.Value
                                                ?? slotProps.data?.Section_Type
                                                ?? ''
                                            ).toLowerCase() === 'section'
                                        "                                      
                                        @input="onPriceOrVolumeChange($event, slotProps.data, 'Material_Price')" 
                                        @blur="onPriceOrVolumeChange($event, slotProps.data, 'Material_Price'); onCellEditCompleteBoQ(slotProps.data);"
                                        :maxFractionDigits="4"
                                        :minFractionDigits="0"
                                       
                                        />
                                    </template>
                                </Column>
                                <Column field="Labour_Price" :hidden="!canViewRKTK">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                        v-model="slotProps.data.Labour_Price"
                                        :maxFractionDigits="4"
                                        :minFractionDigits="0"
                                        :disabled="
                                            (formMode != $FORM_MODE_CREATE && formMode != $FORM_MODE_EDIT)
                                            || String(
                                                slotProps.data?.Section_Type?.Value
                                                ?? slotProps.data?.Section_Type
                                                ?? ''
                                            ).toLowerCase() === 'section'
                                        "
                                        @input="onPriceOrVolumeChange($event, slotProps.data, 'Labour_Price')" 
                                        @blur="onPriceOrVolumeChange($event, slotProps.data, 'Labour_Price'); onCellEditCompleteBoQ(slotProps.data);"
                                    
                                        />
                                    </template>
                                </Column>

                                <!-- MC0 -->
                                <Column field="MC0_Deviation" class="column-min-width">
                                    <template #body="slotProps">
                                        <InputNumber v-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                        v-model="slotProps.data.MC0_Deviation" :maxFractionDigits="6" :minFractionDigits="0"
                                        :disabled="true"
                                        v-lock-input="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="MC0_Volume" class="column-min-width">
                                    <template #body="slotProps">
                                        <InputNumber v-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                        v-model="slotProps.data.MC0_Volume" :maxFractionDigits="6" :minFractionDigits="0"
                                        :disabled="true"
                                        v-lock-input="true"
                                        />
                                    </template>
                                </Column>

                            <!-- MC_Between -->
                            <Column field="MCBetween_Deviation" class="column-min-width">
                                <template #body="slotProps">
                                    <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.MCBetween_Deviation" :maxFractionDigits="6" :minFractionDigits="0"
                                    :disabled="true"
                                    v-lock-input="true"
                                    />
                                </template>
                            </Column>
                            <Column field="MCBetween_Volume" class="column-min-width">
                                <template #body="slotProps">
                                    <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.MCBetween_Volume" :maxFractionDigits="6" :minFractionDigits="0"
                                    :disabled="true"
                                    v-lock-input="true"
                                    />
                                </template>
                            </Column>

                            <!-- MC100 -->
                            <Column field="MC100_Deviation" class="column-min-width">
                                <template #body="slotProps">
                                    <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.MC100_Deviation" :maxFractionDigits="6" :minFractionDigits="0"
                                    :disabled="true"
                                    v-lock-input="true"
                                    />
                                </template>
                            </Column>
                            <Column field="MC100_Volume" class="column-min-width">
                                <template #body="slotProps">
                                    <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.MC100_Volume" :maxFractionDigits="6" :minFractionDigits="0"
                                    :disabled="true"
                                    v-lock-input="true"
                                    />
                                </template>
                            </Column>

                            <!-- RKTK_MC0 -->
                            <Column field="RKTK_MC0_Deviation" class="column-min-width" :hidden="!canViewRKTK">
                                <template #body="slotProps">
                                    <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.RKTK_MC0_Deviation" :maxFractionDigits="4" :minFractionDigits="0"
                                    :disabled="true"
                                    v-lock-input="true"
                                    />
                                    <span v-else-if="slotProps.data.isTotalRow" class="font-bold text-right w-full block">
                                        {{ slotProps.data.Description_Total}}
                                    </span>
                                </template>
                            </Column>
                            <Column field="RKTK_MC0_Amount" class="column-min-width" :hidden="!canViewRKTK">
                                <template #body="slotProps">
                                    <InputNumber v-if=" slotProps.data.isTotalRow" 
                                        v-model="slotProps.data.RKTK_MC0_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                        :disabled="true"
                                        v-lock-input="true"
                                    />
                                    <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                        v-model="slotProps.data.RKTK_MC0_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                        :disabled="true"
                                        v-lock-input="true"
                                    />
                                </template>
                            </Column>

                            <!-- RKTK_MC_Between -->
                            <Column field="RKTK_MCBetween_Deviation" class="column-min-width" :hidden="!canViewRKTK">
                                <template #body="slotProps">
                                    <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.RKTK_MCBetween_Deviation" :maxFractionDigits="4" :minFractionDigits="0"
                                    :disabled="true"
                                    v-lock-input="true"
                                    />
                                    <span v-else-if="slotProps.data.isTotalRow" class="font-bold text-right w-full block">
                                        {{ slotProps.data.Description_Total}}
                                    </span>
                                </template>
                            </Column>
                            <Column field="RKTK_MCBetween_Amount" class="column-min-width" :hidden="!canViewRKTK">
                                <template #body="slotProps">
                                    <InputNumber v-if=" slotProps.data.isTotalRow" 
                                        v-model="slotProps.data.RKTK_MCBetween_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                        :disabled="true"
                                        v-lock-input="true"
                                    />
                                    <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                        v-model="slotProps.data.RKTK_MCBetween_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                        :disabled="true"
                                        v-lock-input="true"
                                    />
                                </template>
                            </Column>

                            <!-- RKTK_MC100 -->
                            <Column field="RKTK_MC100_Deviation" class="column-min-width" :hidden="!canViewRKTK">
                                <template #body="slotProps">
                                    <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.RKTK_MC100_Deviation" :maxFractionDigits="4" :minFractionDigits="0"
                                    :disabled="true"
                                    v-lock-input="true"
                                    />
                                    <span v-else-if="slotProps.data.isTotalRow" class="font-bold text-right w-full block">
                                        {{ slotProps.data.Description_Total}}
                                    </span>
                                </template>
                            </Column>
                            <Column field="RKTK_MC100_Amount" class="column-min-width" :hidden="!canViewRKTK">
                                <template #body="slotProps">
                                    <InputNumber v-if=" slotProps.data.isTotalRow" 
                                        v-model="slotProps.data.RKTK_MC100_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                        :disabled="true"
                                        v-lock-input="true"
                                    />
                                     <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                        v-model="slotProps.data.RKTK_MC100_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                        :disabled="true"
                                        v-lock-input="true"
                                    />
                                </template>
                            </Column>


                            <!-- Contract_MC0 -->
                            <Column field="MC0_Contract_Volume" class="column-min-width">
                                <template #body="slotProps">
                                    <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.MC0_Contract_Volume" :maxFractionDigits="6" :minFractionDigits="0"
                                    :disabled="true"
                                    v-lock-input="true"
                                    />
                                    <span v-else class="font-bold text-right w-full block">
                                        {{ slotProps.data.Description_Total}}
                                    </span>
                                </template>
                            </Column>
                            <Column field="MC0_Contract_Amount" class="column-min-width" :hidden="!canViewRKTK">
                                <template #body="slotProps">
                                    <InputNumber v-model="slotProps.data.MC0_Contract_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                    :disabled="true"
                                    v-lock-input="true"
                                    />
                                </template>
                            </Column>
                            <!-- Contract_MC_Between -->
                            <Column field="MCBetween_Contract_Volume" class="column-min-width">
                                <template #body="slotProps">
                                    <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.MCBetween_Contract_Volume" :maxFractionDigits="6" :minFractionDigits="0"
                                    :disabled="true"
                                    v-lock-input="true"
                                    />
                                    <span v-else class="font-bold text-right w-full block">
                                        {{ slotProps.data.Description_Total}}
                                    </span>
                                </template>
                            </Column>
                            <Column field="MCBetween_Contract_Amount" class="column-min-width" :hidden="!canViewRKTK">
                                <template #body="slotProps">
                                    <InputNumber v-model="slotProps.data.MCBetween_Contract_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                    :disabled="true"
                                    v-lock-input="true"
                                    />
                                </template>
                            </Column>
                            <!-- Contract_MC100 -->
                            <Column field="MC100_Contract_Volume" class="column-min-width">
                                <template #body="slotProps">
                                    <InputNumber v-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.MC100_Contract_Volume" :maxFractionDigits="6" :minFractionDigits="0"
                                    :disabled="true"
                                    v-lock-input="true"
                                    />
                                    <span v-else class="font-bold text-right w-full block">
                                        {{ slotProps.data.Description_Total}}
                                    </span>
                                </template>
                            </Column>
                            <Column field="MC100_Contract_Amount" class="column-min-width" :hidden="!canViewRKTK">
                                <template #body="slotProps">
                                    <InputNumber 
                                    v-model="slotProps.data.MC100_Contract_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                    :disabled="true"
                                    v-lock-input="true"
                                    />
                                </template>
                            </Column>
                             <!-- Contract_Adjust -->
                            <Column field="Temp_Adjust_Contract_Volume" class="column-min-width" :hidden="!canViewRKTK">
                            <template #body="slotProps">
                                <InputNumber 
                                v-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                v-model="slotProps.data.Temp_Adjust_Contract_Volume" :maxFractionDigits="6" :minFractionDigits="0"
                                :disabled="true"
                                v-lock-input="true"
                                />
                                <span v-else-if="slotProps.data.isTotalRow" class="font-bold text-right w-full block">
                                    {{ slotProps.data.Description_Total}}
                                </span>
                            </template>
                            </Column>
                            <Column field="Temp_Adjust_Contract_Amount" class="column-min-width" :hidden="!canViewRKTK">
                            <template #body="slotProps">
                                <InputNumber v-if="slotProps.data.isTotalRow" 
                                    v-model="slotProps.data.Temp_Adjust_Contract_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                    :disabled="true"
                                    v-lock-input="true"
                                />
                                <InputNumber v-else-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.Temp_Adjust_Contract_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                    :disabled="true"
                                    v-lock-input="true"
                                />
                            </template>
                            </Column>
                    </DataTable>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </Card>
    <!--BoQ Addendum MC Between-->
    <Card class="boq-card">
        <template #header>
            <div class="card-header-title">
                <span class="text-900 font-bold">BoQ SPO Addendum (From MC-in Between)</span>
            </div>
        </template>
        <template #content>
            <div class="p-inputtext-sm p-fluid">
                <div class="grid">
                    <div class="col-12">
                        <div class="table-wrapper-fixed-header">
                            <DataTable
                                :value="boqAddendumMCBetween"
                                responsiveLayout="scroll"
                                class="p-datatable-sm editable-cells-table table-fixed-header boq-addendum-table"
                                style="width: 100%; white-space: nowrap;"
                                editMode="cell"
                            >
                            <!-- ColumnGroup Header -->
                            <ColumnGroup type="header">
                                <Row>
                                    <Column :header="$t('type')" :rowspan="2" />
                                    <Column :header="$t('no')" :rowspan="2" />
                                    <Column :header="$t('scope')" :rowspan="2" />
                                    <Column :header="$t('unit')" :rowspan="2" />

                                    <Column :header="$t('initial_contract')" :colspan="canViewRKTK ? 5 : 2" />
                                    <Column header="Updated (Latest)" :colspan="2" :hidden="!canViewRKTK" />
                                    <Column :header="$t('MC0')" :colspan="2" />
                                    <Column :header="$t('MC_Between')" :colspan="2" />
                                    <Column :header="$t('MC100')" :colspan="2" />
                                    <Column :header="$t('RKTK_MC0')" :colspan="2" :hidden="!canViewRKTK" />
                                    <Column :header="$t('RKTK_MC_Between')" :colspan="2" :hidden="!canViewRKTK" />
                                    <Column :header="$t('RKTK_MC100')" :colspan="2" :hidden="!canViewRKTK" />
                                    <Column :header="$t('Contract_MC0')" :colspan="canViewRKTK ? 2 : 1" />
                                    <Column :header="$t('Contract_MC_Between')" :colspan="canViewRKTK ? 2 : 1" />
                                    <Column :header="$t('Contract_MC100')" :colspan="canViewRKTK ? 2 : 1" />
                                    <Column :header="$t('Contract_Adjust')" :colspan="2" :hidden="!canViewRKTK" />
                                </Row>

                                <Row>
                                    <!-- initial_contract -->
                                    <Column :header="$t('Volume')" />
                                    <Column :header="$t('material_price')" :hidden="!canViewRKTK" />
                                    <Column :header="$t('labour_price')" :hidden="!canViewRKTK" />
                                    <Column :header="$t('Amount')" :hidden="!canViewRKTK" />
                                    <Column :header="$t('percent_bobot')" />
                                    <!-- Updated (Latest) -->
                                    <Column :header="$t('material_price')" :hidden="!canViewRKTK" />
                                    <Column :header="$t('labour_price')" :hidden="!canViewRKTK" />
                                    <!-- MC0 -->
                                    <Column :header="$t('Deviasi')" />
                                    <Column :header="$t('Volume')" />
                                    <!-- MC_Between -->
                                    <Column :header="$t('Deviasi')" />
                                    <Column :header="$t('Volume')" />
                                    <!-- MC100 -->
                                    <Column :header="$t('Deviasi')" />
                                    <Column :header="$t('Volume')" />
                                    <!-- RKTK_MC0 -->
                                    <Column :header="$t('Deviasi')" :hidden="!canViewRKTK" />
                                    <Column :header="$t('Amount')" :hidden="!canViewRKTK" />
                                    <!-- RKTK_MC_Between -->
                                    <Column :header="$t('Deviasi')" :hidden="!canViewRKTK" />
                                    <Column :header="$t('Amount')" :hidden="!canViewRKTK" />
                                    <!-- RKTK_MC100 -->
                                    <Column :header="$t('Deviasi')" :hidden="!canViewRKTK" />
                                    <Column :header="$t('Amount')" :hidden="!canViewRKTK" />
                                    <!-- Contract_MC0 -->
                                    <Column :header="$t('Volume')" />
                                    <Column :header="$t('Amount')" :hidden="!canViewRKTK" />
                                    <!-- Contract_MC_Between -->
                                    <Column :header="$t('Volume')" />
                                    <Column :header="$t('Amount')" :hidden="!canViewRKTK" />
                                    <!-- Contract_MC100 -->
                                    <Column :header="$t('Volume')" />
                                    <Column :header="$t('Amount')" :hidden="!canViewRKTK" />
                                    <!-- Contract_Adjust -->
                                    <Column :header="$t('Volume')" :hidden="!canViewRKTK" />
                                    <Column :header="$t('Amount')" :hidden="!canViewRKTK" />
                                </Row>
                            </ColumnGroup>
                                <Column field="Section_Type">
                                    <template #body="slotProps">
                                        <InputText
                                         v-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                        v-model="slotProps.data.Section_Type"
                                        :disabled="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="No_BoQ">
                                    <template #body="slotProps">
                                        <InputText
                                         v-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                        v-model="slotProps.data.No_BoQ"
                                        :disabled="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Scope">
                                    <template #body="slotProps">
                                        <Textarea 
                                        v-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                        v-model="slotProps.data.Scope"
                                        :disabled="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Unit">
                                    <template #body="slotProps">
                                        <InputText
                                        v-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                        v-model="slotProps.data.Unit"
                                        :disabled="true"
                                        />
                                    </template>
                                </Column>

                                <!-- Initial Contract -->
                                <Column field="Initial_Contract_Volume" class="column-min-width">
                                    <template #body="slotProps">
                                        <InputNumber v-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                            v-model="slotProps.data.Initial_Contract_Volume" :maxFractionDigits="6" :minFractionDigits="0" :min="-9999999999"
                                        :disabled="true"
                                         v-lock-input="true"
                                        />
                                        <span v-else-if="slotProps.data.isTotalRow" class="font-bold text-right w-full block">
                                            {{ slotProps.data.Description_Total }}
                                        </span>
                                    </template>
                                </Column>
                                <Column field="Initial_Material_Price" :hidden="!canViewRKTK">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                        :modelValue="initialMaterialPrice(slotProps.data)"
                                         disabled
                                        v-lock-input="true"
                                        :maxFractionDigits="4"
                                        :minFractionDigits="0"
                                        />
                                    </template>
                                </Column>
                                <Column field="Initial_Labour_Price" :hidden="!canViewRKTK">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                        :modelValue="initialLabourPrice(slotProps.data)"
                                        :maxFractionDigits="4"
                                        :minFractionDigits="0"
                                        disabled
                                        v-lock-input="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Initial_Contract_Amount" class="column-min-width" :hidden="!canViewRKTK">
                                    <template #body="slotProps">
                                        <InputNumber v-if=" slotProps.data.isTotalRow"
                                                v-model="slotProps.data.Initial_Contract_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                                :disabled="true"
                                                 v-lock-input="true"
                                            />
                                            <InputNumber v-else-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                                v-model="slotProps.data.Initial_Contract_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                                :disabled="true"
                                                 v-lock-input="true"
                                            />
                                    </template>
                                </Column>
                                <!-- % Bobot -->
                                <Column field="Percent_Bobot">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                        :modelValue="percentBobotAddendum(slotProps.data)"
                                         disabled
                                        v-lock-input="true"
                                        suffix=" %"
                                        :maxFractionDigits="2"
                                        :minFractionDigits="2"
                                        />
                                    </template>
                                </Column>

                                <!-- Updated (Latest) -->
                                <Column field="Material_Price" :hidden="!canViewRKTK">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                        v-model="slotProps.data.Material_Price"
                                         :disabled="
                                            (formMode != $FORM_MODE_CREATE && formMode != $FORM_MODE_EDIT)
                                            || String(
                                                slotProps.data?.Section_Type?.Value
                                                ?? slotProps.data?.Section_Type
                                                ?? ''
                                            ).toLowerCase() === 'section'
                                        "                                      
                                        @input="onPriceOrVolumeChange($event, slotProps.data, 'Material_Price')" 
                                        @blur="onPriceOrVolumeChange($event, slotProps.data, 'Material_Price'); onCellEditCompleteBoQ(slotProps.data);"
                                        :maxFractionDigits="4"
                                        :minFractionDigits="0"
                                       
                                        />
                                    </template>
                                </Column>
                                <Column field="Labour_Price" :hidden="!canViewRKTK">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                        v-model="slotProps.data.Labour_Price"
                                        :maxFractionDigits="4"
                                        :minFractionDigits="0"
                                        :disabled="
                                            (formMode != $FORM_MODE_CREATE && formMode != $FORM_MODE_EDIT)
                                            || String(
                                                slotProps.data?.Section_Type?.Value
                                                ?? slotProps.data?.Section_Type
                                                ?? ''
                                            ).toLowerCase() === 'section'
                                        "
                                        @input="onPriceOrVolumeChange($event, slotProps.data, 'Labour_Price')" 
                                        @blur="onPriceOrVolumeChange($event, slotProps.data, 'Labour_Price'); onCellEditCompleteBoQ(slotProps.data);"
                                    
                                        />
                                    </template>
                                </Column>

                                <!-- MC0 -->
                                <Column field="MC0_Deviation" class="column-min-width">
                                    <template #body="slotProps">
                                        <InputNumber v-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                        v-model="slotProps.data.MC0_Deviation" :maxFractionDigits="6" :minFractionDigits="0"
                                        :disabled="true"
                                         v-lock-input="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="MC0_Volume" class="column-min-width">
                                    <template #body="slotProps">
                                        <InputNumber v-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                        v-model="slotProps.data.MC0_Volume" :maxFractionDigits="6" :minFractionDigits="0"
                                        :disabled="true"
                                         v-lock-input="true"
                                        />
                                    </template>
                                </Column>

                            <!-- MC_Between -->
                            <Column field="MCBetween_Deviation" class="column-min-width">
                                <template #body="slotProps">
                                    <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.MCBetween_Deviation" :maxFractionDigits="6" :minFractionDigits="0"
                                    :disabled="true"
                                     v-lock-input="true"
                                    />
                                </template>
                            </Column>
                            <Column field="MCBetween_Volume" class="column-min-width">
                                <template #body="slotProps">
                                    <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.MCBetween_Volume" :maxFractionDigits="6" :minFractionDigits="0"
                                    :disabled="true"
                                     v-lock-input="true"
                                    />
                                </template>
                            </Column>

                            <!-- MC100 -->
                            <Column field="MC100_Deviation" class="column-min-width">
                                <template #body="slotProps">
                                    <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.MC100_Deviation" :maxFractionDigits="6" :minFractionDigits="0"
                                    :disabled="true"
                                     v-lock-input="true"
                                    />
                                </template>
                            </Column>
                            <Column field="MC100_Volume" class="column-min-width">
                                <template #body="slotProps">
                                    <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.MC100_Volume" :maxFractionDigits="6" :minFractionDigits="0"
                                    :disabled="true"
                                    />
                                </template>
                            </Column>

                            <!-- RKTK_MC0 -->
                            <Column field="RKTK_MC0_Deviation" class="column-min-width" :hidden="!canViewRKTK">
                                <template #body="slotProps">
                                    <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.RKTK_MC0_Deviation" :maxFractionDigits="4" :minFractionDigits="0"
                                    :disabled="true"
                                     v-lock-input="true"
                                    />
                                    <span v-else-if="slotProps.data.isTotalRow" class="font-bold text-right w-full block">
                                        {{ slotProps.data.Description_Total}}
                                    </span>
                                </template>
                            </Column>
                            <Column field="RKTK_MC0_Amount" class="column-min-width" :hidden="!canViewRKTK">
                                <template #body="slotProps">
                                    <InputNumber v-if=" slotProps.data.isTotalRow" 
                                        v-model="slotProps.data.RKTK_MC0_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                        :disabled="true"
                                         v-lock-input="true"
                                    />
                                    <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                        v-model="slotProps.data.RKTK_MC0_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                        :disabled="true"
                                         v-lock-input="true"
                                    />
                                </template>
                            </Column>

                            <!-- RKTK_MC_Between -->
                            <Column field="RKTK_MCBetween_Deviation" class="column-min-width" :hidden="!canViewRKTK">
                                <template #body="slotProps">
                                    <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.RKTK_MCBetween_Deviation" :maxFractionDigits="4" :minFractionDigits="0"
                                    :disabled="true"
                                     v-lock-input="true"
                                    />
                                    <span v-else-if="slotProps.data.isTotalRow" class="font-bold text-right w-full block">
                                        {{ slotProps.data.Description_Total}}
                                    </span>
                                </template>
                            </Column>
                            <Column field="RKTK_MCBetween_Amount" class="column-min-width" :hidden="!canViewRKTK">
                                <template #body="slotProps">
                                    <InputNumber v-if=" slotProps.data.isTotalRow" 
                                        v-model="slotProps.data.RKTK_MCBetween_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                        :disabled="true"
                                         v-lock-input="true"
                                    />
                                    <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                        v-model="slotProps.data.RKTK_MCBetween_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                        :disabled="true"
                                         v-lock-input="true"
                                    />
                                </template>
                            </Column>

                            <!-- RKTK_MC100 -->
                            <Column field="RKTK_MC100_Deviation" class="column-min-width" :hidden="!canViewRKTK">
                                <template #body="slotProps">
                                    <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.RKTK_MC100_Deviation" :maxFractionDigits="4" :minFractionDigits="0"
                                    :disabled="true"
                                     v-lock-input="true"
                                    />
                                    <span v-else-if="slotProps.data.isTotalRow" class="font-bold text-right w-full block">
                                        {{ slotProps.data.Description_Total}}
                                    </span>
                                </template>
                            </Column>
                            <Column field="RKTK_MC100_Amount" class="column-min-width" :hidden="!canViewRKTK">
                                <template #body="slotProps">
                                    <InputNumber v-if=" slotProps.data.isTotalRow" 
                                        v-model="slotProps.data.RKTK_MC100_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                        :disabled="true"
                                         v-lock-input="true"
                                    />
                                     <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                        v-model="slotProps.data.RKTK_MC100_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                        :disabled="true"
                                         v-lock-input="true"
                                    />
                                </template>
                            </Column>


                            <!-- Contract_MC0 -->
                            <Column field="MC0_Contract_Volume" class="column-min-width">
                                <template #body="slotProps">
                                    <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.MC0_Contract_Volume" :maxFractionDigits="6" :minFractionDigits="0"
                                    :disabled="true"
                                     v-lock-input="true"
                                    />
                                    <span v-else class="font-bold text-right w-full block">
                                        {{ slotProps.data.Description_Total}}
                                    </span>
                                </template>
                            </Column>
                            <Column field="MC0_Contract_Amount" class="column-min-width" :hidden="!canViewRKTK">
                                <template #body="slotProps">
                                    <InputNumber v-model="slotProps.data.MC0_Contract_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                    :disabled="true"
                                     v-lock-input="true"
                                    />
                                </template>
                            </Column>
                            <!-- Contract_MC_Between -->
                            <Column field="MCBetween_Contract_Volume" class="column-min-width">
                                <template #body="slotProps">
                                    <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.MCBetween_Contract_Volume" :maxFractionDigits="6" :minFractionDigits="0"
                                    :disabled="true"
                                    v-lock-input="true"
                                    />
                                    <span v-else class="font-bold text-right w-full block">
                                        {{ slotProps.data.Description_Total}}
                                    </span>
                                </template>
                            </Column>
                            <Column field="MCBetween_Contract_Amount" class="column-min-width" :hidden="!canViewRKTK">
                                <template #body="slotProps">
                                    <InputNumber v-model="slotProps.data.MCBetween_Contract_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                    :disabled="true"
                                    v-lock-input="true"
                                    />
                                </template>
                            </Column>
                            <!-- Contract_MC100 -->
                            <Column field="MC100_Contract_Volume" class="column-min-width">
                                <template #body="slotProps">
                                    <InputNumber v-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.MC100_Contract_Volume" :maxFractionDigits="6" :minFractionDigits="0"
                                    :disabled="true"
                                    v-lock-input="true"
                                    />
                                    <span v-else class="font-bold text-right w-full block">
                                        {{ slotProps.data.Description_Total}}
                                    </span>
                                </template>
                            </Column>
                            <Column field="MC100_Contract_Amount" class="column-min-width" :hidden="!canViewRKTK">
                                <template #body="slotProps">
                                    <InputNumber 
                                    v-model="slotProps.data.MC100_Contract_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                    :disabled="true"
                                    v-lock-input="true"
                                    />
                                </template>
                            </Column>
                             <!-- Contract_Adjust -->
                            <Column field="Temp_Adjust_Contract_Volume" class="column-min-width" :hidden="!canViewRKTK">
                            <template #body="slotProps">
                                <InputNumber 
                                v-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                v-model="slotProps.data.Temp_Adjust_Contract_Volume" :maxFractionDigits="6" :minFractionDigits="0"
                                :disabled="true"
                                v-lock-input="true"
                                />
                                <span v-else-if="slotProps.data.isTotalRow" class="font-bold text-right w-full block">
                                    {{ slotProps.data.Description_Total}}
                                </span>
                            </template>
                            </Column>
                            <Column field="Temp_Adjust_Contract_Amount" class="column-min-width" :hidden="!canViewRKTK">
                            <template #body="slotProps">
                                <InputNumber v-if="slotProps.data.isTotalRow" 
                                    v-model="slotProps.data.Temp_Adjust_Contract_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                    :disabled="true"
                                    v-lock-input="true"
                                />
                                <InputNumber v-else-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.Temp_Adjust_Contract_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                    :disabled="true"
                                    v-lock-input="true"
                                />
                            </template>
                            </Column>
                    </DataTable>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </Card>
    <!--BoQ Addendum MC 100-->
    <Card class="boq-card">
        <template #header>
            <div class="card-header-title">
                <span class="text-900 font-bold">BoQ SPO Addendum (From MC-100)</span>
            </div>
        </template>
        <template #content>
            <div class="p-inputtext-sm p-fluid">
                <div class="grid">
                    <div class="col-12">
                        <div class="table-wrapper-fixed-header">
                            <DataTable
                                :value="boqAddendumMC100"
                                responsiveLayout="scroll"
                                class="p-datatable-sm editable-cells-table table-fixed-header boq-addendum-table"
                                style="width: 100%; white-space: nowrap;"
                                editMode="cell"
                            >
                            <!-- ColumnGroup Header -->
                            <ColumnGroup type="header">
                                <Row>
                                    <Column :header="$t('type')" :rowspan="2" />
                                    <Column :header="$t('no')" :rowspan="2" />
                                    <Column :header="$t('scope')" :rowspan="2" />
                                    <Column :header="$t('unit')" :rowspan="2" />

                                    <Column :header="$t('initial_contract')" :colspan="canViewRKTK ? 5 : 2" />
                                    <Column header="Updated (Latest)" :colspan="2" :hidden="!canViewRKTK" />
                                    <Column :header="$t('MC0')" :colspan="2" />
                                    <Column :header="$t('MC_Between')" :colspan="2" />
                                    <Column :header="$t('MC100')" :colspan="2" />
                                    <Column :header="$t('RKTK_MC0')" :colspan="2" :hidden="!canViewRKTK" />
                                    <Column :header="$t('RKTK_MC_Between')" :colspan="2" :hidden="!canViewRKTK" />
                                    <Column :header="$t('RKTK_MC100')" :colspan="2" :hidden="!canViewRKTK" />
                                    <Column :header="$t('Contract_MC0')" :colspan="canViewRKTK ? 2 : 1" />
                                    <Column :header="$t('Contract_MC_Between')" :colspan="canViewRKTK ? 2 : 1" />
                                    <Column :header="$t('Contract_MC100')" :colspan="canViewRKTK ? 2 : 1" />
                                    <Column :header="$t('Contract_Adjust')" :colspan="2" :hidden="!canViewRKTK" />
                                </Row>

                                <Row>
                                    <!-- initial_contract -->
                                    <Column :header="$t('Volume')" />
                                    <Column :header="$t('material_price')" :hidden="!canViewRKTK" />
                                    <Column :header="$t('labour_price')" :hidden="!canViewRKTK" />
                                    <Column :header="$t('Amount')" :hidden="!canViewRKTK" />
                                    <Column :header="$t('percent_bobot')" />
                                    <!-- Updated (Latest) -->
                                    <Column :header="$t('material_price')" :hidden="!canViewRKTK" />
                                    <Column :header="$t('labour_price')" :hidden="!canViewRKTK" />
                                    <!-- MC0 -->
                                    <Column :header="$t('Deviasi')" />
                                    <Column :header="$t('Volume')" />
                                    <!-- MC_Between -->
                                    <Column :header="$t('Deviasi')" />
                                    <Column :header="$t('Volume')" />
                                    <!-- MC100 -->
                                    <Column :header="$t('Deviasi')" />
                                    <Column :header="$t('Volume')" />
                                    <!-- RKTK_MC0 -->
                                    <Column :header="$t('Deviasi')" :hidden="!canViewRKTK" />
                                    <Column :header="$t('Amount')" :hidden="!canViewRKTK" />
                                    <!-- RKTK_MC_Between -->
                                    <Column :header="$t('Deviasi')" :hidden="!canViewRKTK" />
                                    <Column :header="$t('Amount')" :hidden="!canViewRKTK" />
                                    <!-- RKTK_MC100 -->
                                    <Column :header="$t('Deviasi')" :hidden="!canViewRKTK" />
                                    <Column :header="$t('Amount')" :hidden="!canViewRKTK" />
                                    <!-- Contract_MC0 -->
                                    <Column :header="$t('Volume')" />
                                    <Column :header="$t('Amount')" :hidden="!canViewRKTK" />
                                    <!-- Contract_MC_Between -->
                                    <Column :header="$t('Volume')" />
                                    <Column :header="$t('Amount')" :hidden="!canViewRKTK" />
                                    <!-- Contract_MC100 -->
                                    <Column :header="$t('Volume')" />
                                    <Column :header="$t('Amount')" :hidden="!canViewRKTK" />
                                    <!-- Contract_Adjust -->
                                    <Column :header="$t('Volume')" :hidden="!canViewRKTK" />
                                    <Column :header="$t('Amount')" :hidden="!canViewRKTK" />
                                </Row>
                            </ColumnGroup>
                                <Column field="Section_Type">
                                    <template #body="slotProps">
                                        <InputText
                                         v-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                        v-model="slotProps.data.Section_Type"
                                        :disabled="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="No_BoQ">
                                    <template #body="slotProps">
                                        <InputText
                                         v-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                        v-model="slotProps.data.No_BoQ"
                                        :disabled="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Scope">
                                    <template #body="slotProps">
                                        <Textarea 
                                        v-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                        v-model="slotProps.data.Scope"
                                        :disabled="true"
                                         
                                        />
                                    </template>
                                </Column>
                                <Column field="Unit">
                                    <template #body="slotProps">
                                        <InputText
                                        v-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                        v-model="slotProps.data.Unit"
                                        :disabled="true"
                                        
                                        />
                                    </template>
                                </Column>

                                <!-- Initial Contract -->
                                <Column field="Initial_Contract_Volume" class="column-min-width">
                                    <template #body="slotProps">
                                        <InputNumber v-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                            v-model="slotProps.data.Initial_Contract_Volume" :maxFractionDigits="6" :minFractionDigits="0" :min="-9999999999"
                                        :disabled="true"
                                         v-lock-input="true"
                                        />
                                        <span v-else-if="slotProps.data.isTotalRow" class="font-bold text-right w-full block">
                                            {{ slotProps.data.Description_Total }}
                                        </span>
                                    </template>
                                </Column>
                                <Column field="Initial_Material_Price" :hidden="!canViewRKTK">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                        :modelValue="initialMaterialPrice(slotProps.data)"
                                         disabled
                                        v-lock-input="true"
                                        :maxFractionDigits="4"
                                        :minFractionDigits="0"
                                        />
                                    </template>
                                </Column>
                                <Column field="Initial_Labour_Price" :hidden="!canViewRKTK">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                        :modelValue="initialLabourPrice(slotProps.data)"
                                        :maxFractionDigits="4"
                                        :minFractionDigits="0"
                                        disabled
                                        v-lock-input="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="Initial_Contract_Amount" class="column-min-width" :hidden="!canViewRKTK">
                                    <template #body="slotProps">
                                        <InputNumber v-if=" slotProps.data.isTotalRow"
                                                v-model="slotProps.data.Initial_Contract_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                                :disabled="true"
                                                 v-lock-input="true"
                                            />
                                            <InputNumber v-else-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                                v-model="slotProps.data.Initial_Contract_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                                :disabled="true"
                                                 v-lock-input="true"
                                            />
                                    </template>
                                </Column>
                                <!-- % Bobot -->
                                <Column field="Percent_Bobot">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                        :modelValue="percentBobotAddendum(slotProps.data)"
                                         disabled
                                        v-lock-input="true"
                                        suffix=" %"
                                        :maxFractionDigits="2"
                                        :minFractionDigits="2"
                                        />
                                    </template>
                                </Column>

                                <!-- Updated (Latest) -->
                                <Column field="Material_Price" :hidden="!canViewRKTK">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                        v-model="slotProps.data.Material_Price"
                                         :disabled="
                                            (formMode != $FORM_MODE_CREATE && formMode != $FORM_MODE_EDIT)
                                            || String(
                                                slotProps.data?.Section_Type?.Value
                                                ?? slotProps.data?.Section_Type
                                                ?? ''
                                            ).toLowerCase() === 'section'
                                        "                                      
                                        @input="onPriceOrVolumeChange($event, slotProps.data, 'Material_Price')" 
                                        @blur="onPriceOrVolumeChange($event, slotProps.data, 'Material_Price'); onCellEditCompleteBoQ(slotProps.data);"
                                        :maxFractionDigits="4"
                                        :minFractionDigits="0"
                                       
                                        />
                                    </template>
                                </Column>
                                <Column field="Labour_Price" :hidden="!canViewRKTK">
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow"
                                        v-model="slotProps.data.Labour_Price"
                                        :maxFractionDigits="4"
                                        :minFractionDigits="0"
                                        :disabled="
                                            (formMode != $FORM_MODE_CREATE && formMode != $FORM_MODE_EDIT)
                                            || String(
                                                slotProps.data?.Section_Type?.Value
                                                ?? slotProps.data?.Section_Type
                                                ?? ''
                                            ).toLowerCase() === 'section'
                                        "
                                        @input="onPriceOrVolumeChange($event, slotProps.data, 'Labour_Price')" 
                                        @blur="onPriceOrVolumeChange($event, slotProps.data, 'Labour_Price'); onCellEditCompleteBoQ(slotProps.data);"
                                    
                                        />
                                    </template>
                                </Column>

                                <!-- MC0 -->
                                <Column field="MC0_Deviation" class="column-min-width">
                                    <template #body="slotProps">
                                        <InputNumber v-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                        v-model="slotProps.data.MC0_Deviation" :maxFractionDigits="6" :minFractionDigits="0"
                                        :disabled="true"
                                         v-lock-input="true"
                                        />
                                    </template>
                                </Column>
                                <Column field="MC0_Volume" class="column-min-width">
                                    <template #body="slotProps">
                                        <InputNumber v-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                        v-model="slotProps.data.MC0_Volume" :maxFractionDigits="6" :minFractionDigits="0"
                                        :disabled="true"
                                         v-lock-input="true"
                                        />
                                    </template>
                                </Column>

                            <!-- MC_Between -->
                            <Column field="MCBetween_Deviation" class="column-min-width">
                                <template #body="slotProps">
                                    <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.MCBetween_Deviation" :maxFractionDigits="6" :minFractionDigits="0"
                                    :disabled="true"
                                     v-lock-input="true"
                                    />
                                </template>
                            </Column>
                            <Column field="MCBetween_Volume" class="column-min-width">
                                <template #body="slotProps">
                                    <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.MCBetween_Volume" :maxFractionDigits="6" :minFractionDigits="0"
                                    :disabled="true"
                                     v-lock-input="true"
                                    />
                                </template>
                            </Column>

                            <!-- MC100 -->
                            <Column field="MC100_Deviation" class="column-min-width">
                                <template #body="slotProps">
                                    <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.MC100_Deviation" :maxFractionDigits="6" :minFractionDigits="0"
                                    :disabled="true"
                                     v-lock-input="true"
                                    />
                                </template>
                            </Column>
                            <Column field="MC100_Volume" class="column-min-width">
                                <template #body="slotProps">
                                    <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.MC100_Volume" :maxFractionDigits="6" :minFractionDigits="0"
                                    :disabled="true"
                                     v-lock-input="true"
                                    />
                                </template>
                            </Column>

                            <!-- RKTK_MC0 -->
                            <Column field="RKTK_MC0_Deviation" class="column-min-width" :hidden="!canViewRKTK">
                                <template #body="slotProps">
                                    <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.RKTK_MC0_Deviation" :maxFractionDigits="4" :minFractionDigits="0"
                                    :disabled="true"
                                     v-lock-input="true"
                                    />
                                    <span v-else-if="slotProps.data.isTotalRow" class="font-bold text-right w-full block">
                                        {{ slotProps.data.Description_Total}}
                                    </span>
                                </template>
                            </Column>
                            <Column field="RKTK_MC0_Amount" class="column-min-width" :hidden="!canViewRKTK">
                                <template #body="slotProps">
                                    <InputNumber v-if=" slotProps.data.isTotalRow" 
                                        v-model="slotProps.data.RKTK_MC0_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                        :disabled="true"
                                         v-lock-input="true"
                                    />
                                    <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                        v-model="slotProps.data.RKTK_MC0_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                        :disabled="true"
                                         v-lock-input="true"
                                    />
                                </template>
                            </Column>

                            <!-- RKTK_MC_Between -->
                            <Column field="RKTK_MCBetween_Deviation" class="column-min-width" :hidden="!canViewRKTK">
                                <template #body="slotProps">
                                    <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.RKTK_MCBetween_Deviation" :maxFractionDigits="4" :minFractionDigits="0"
                                    :disabled="true"
                                     v-lock-input="true"
                                    />
                                    <span v-else-if="slotProps.data.isTotalRow" class="font-bold text-right w-full block">
                                        {{ slotProps.data.Description_Total}}
                                    </span>
                                </template>
                            </Column>
                            <Column field="RKTK_MCBetween_Amount" class="column-min-width" :hidden="!canViewRKTK">
                                <template #body="slotProps">
                                    <InputNumber v-if=" slotProps.data.isTotalRow" 
                                        v-model="slotProps.data.RKTK_MCBetween_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                        :disabled="true"
                                         v-lock-input="true"
                                    />
                                    <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                        v-model="slotProps.data.RKTK_MCBetween_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                        :disabled="true"
                                         v-lock-input="true"
                                    />
                                </template>
                            </Column>

                            <!-- RKTK_MC100 -->
                            <Column field="RKTK_MC100_Deviation" class="column-min-width" :hidden="!canViewRKTK">
                                <template #body="slotProps">
                                    <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.RKTK_MC100_Deviation" :maxFractionDigits="4" :minFractionDigits="0"
                                    :disabled="true"
                                     v-lock-input="true"
                                    />
                                    <span v-else-if="slotProps.data.isTotalRow" class="font-bold text-right w-full block">
                                        {{ slotProps.data.Description_Total}}
                                    </span>
                                </template>
                            </Column>
                            <Column field="RKTK_MC100_Amount" class="column-min-width" :hidden="!canViewRKTK">
                                <template #body="slotProps">
                                    <InputNumber v-if=" slotProps.data.isTotalRow" 
                                        v-model="slotProps.data.RKTK_MC100_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                        :disabled="true"
                                         v-lock-input="true"
                                    />
                                     <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                        v-model="slotProps.data.RKTK_MC100_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                        :disabled="true"
                                         v-lock-input="true"
                                    />
                                </template>
                            </Column>


                            <!-- Contract_MC0 -->
                            <Column field="MC0_Contract_Volume" class="column-min-width">
                                <template #body="slotProps">
                                    <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.MC0_Contract_Volume" :maxFractionDigits="6" :minFractionDigits="0"
                                    :disabled="true"
                                     v-lock-input="true"
                                    />
                                    <span v-else class="font-bold text-right w-full block">
                                        {{ slotProps.data.Description_Total}}
                                    </span>
                                </template>
                            </Column>
                            <Column field="MC0_Contract_Amount" class="column-min-width" :hidden="!canViewRKTK">
                                <template #body="slotProps">
                                    <InputNumber v-model="slotProps.data.MC0_Contract_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                    :disabled="true"
                                     v-lock-input="true"
                                    />
                                </template>
                            </Column>
                            <!-- Contract_MC_Between -->
                            <Column field="MCBetween_Contract_Volume" class="column-min-width">
                                <template #body="slotProps">
                                    <InputNumber v-if=" !slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.MCBetween_Contract_Volume" :maxFractionDigits="6" :minFractionDigits="0"
                                    :disabled="true"
                                     v-lock-input="true"
                                    />
                                    <span v-else class="font-bold text-right w-full block">
                                        {{ slotProps.data.Description_Total}}
                                    </span>
                                </template>
                            </Column>
                            <Column field="MCBetween_Contract_Amount" class="column-min-width" :hidden="!canViewRKTK">
                                <template #body="slotProps">
                                    <InputNumber v-model="slotProps.data.MCBetween_Contract_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                    :disabled="true"
                                     v-lock-input="true"
                                    />
                                </template>
                            </Column>
                            <!-- Contract_MC100 -->
                            <Column field="MC100_Contract_Volume" class="column-min-width">
                                <template #body="slotProps">
                                    <InputNumber v-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.MC100_Contract_Volume" :maxFractionDigits="6" :minFractionDigits="0"
                                    :disabled="true"
                                     v-lock-input="true"
                                    />
                                    <span v-else class="font-bold text-right w-full block">
                                        {{ slotProps.data.Description_Total}}
                                    </span>
                                </template>
                            </Column>
                            <Column field="MC100_Contract_Amount" class="column-min-width" :hidden="!canViewRKTK">
                                <template #body="slotProps">
                                    <InputNumber 
                                    v-model="slotProps.data.MC100_Contract_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                    :disabled="true"
                                     v-lock-input="true"
                                    />
                                </template>
                            </Column>
                             <!-- Contract_Adjust -->
                            <Column field="Temp_Adjust_Contract_Volume" class="column-min-width" :hidden="!canViewRKTK">
                            <template #body="slotProps">
                                <InputNumber 
                                v-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                v-model="slotProps.data.Temp_Adjust_Contract_Volume" :maxFractionDigits="6" :minFractionDigits="0"
                                :disabled="true"
                                v-lock-input="true"
                                />
                                <span v-else-if="slotProps.data.isTotalRow" class="font-bold text-right w-full block">
                                    {{ slotProps.data.Description_Total}}
                                </span>
                            </template>
                            </Column>
                            <Column field="Temp_Adjust_Contract_Amount" class="column-min-width" :hidden="!canViewRKTK">
                            <template #body="slotProps">
                                <InputNumber v-if="slotProps.data.isTotalRow" 
                                    v-model="slotProps.data.Temp_Adjust_Contract_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                    :disabled="true"
                                    v-lock-input="true"
                                />
                                <InputNumber v-else-if="!slotProps.data.isTotalRow && !slotProps.data.isFinalTotalRow" 
                                    v-model="slotProps.data.Temp_Adjust_Contract_Amount" :maxFractionDigits="4" :minFractionDigits="0"
                                    :disabled="true"
                                    v-lock-input="true"
                                />
                            </template>
                            </Column>
                    </DataTable>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </Card>
    <div class="col-12">
        <TabView>
            <TabPanel :header="$t('Change_History')">
                <ChangeHistory v-if="this.header" :modelValue="this.boqChangeLog" :dataRequestLog="this.dataChangesLog" :mode="this.formMode"></ChangeHistory>
            </TabPanel>
        </TabView>
     </div>
    </div>
</template>
<script>
export default{
    props:{
            mode:{
                type:String,
                default: ""
            },
            header:{
                type:Object,
                default:null
            },
            canViewRKTK:{
                type:Boolean,
                default:false
            }
        },
    data(){
        return{
            DoneMC : false,
            DoneAddendum : false,
            Is_Additional : false,
            CanIputScope : true,
            detailLog : [],
            dataChangesLog:this.$dataChangesLog2,
            selectedFile: null,
            uploadMessage: '',
            uploadMessageType: 'info',
            isUploading: false,
            url: this.$API_URL + "maindata/",
            tableReady: false,
        }
    },
    watch: {
        header(val) {
            if (val) {
            this.$nextTick(() => {
                setTimeout(() => {
                this.tableReady = true;
                }, 50); 
            });
            }
        }
    },
    computed:{
        // Tanpa otorisasi view RKTK, BoQ hanya bisa dilihat (semua kolom Price di hide)
        formMode(){
            return this.canViewRKTK ? this.mode : this.$FORM_MODE_VIEW;
        },
        // Filter log changes yang berkaitan dengan price
        boqChangeLog(){
            const logs = this.header?.DetailLogBoQ || [];
            if (this.canViewRKTK) return logs;

            const hiddenColumns = [
                'Initial_Contract_Amount',
                'Material_Price',
                'Labour_Price',
                'Initial_Material_Price',
                'Initial_Labour_Price',
                'RKTK_MC0_Amount',
                'RKTK_MC0_Deviation',
                'RKTK_MCBetween_Amount',
                'RKTK_MCBetween_Deviation',
                'RKTK_MC100_Amount',
                'RKTK_MC100_Deviation',
                'MC0_Contract_Amount',
                'MCBetween_Contract_Amount',
                'MC100_Contract_Amount',
            ];

            return logs.filter(log => !hiddenColumns.includes(log.ColumnName));
        },
        boqCombined() {
            this.DoneMC = this.header?.DoneMC || false;
            this.DoneAddendum = this.header?.DoneAddendum || false;
            this.Is_Additional = this.header?.Is_Additional || false;
            this.CanIputScope = this.header?.CanIputScope || false; 
            const main = this.header?.BoQ_MAIN || [];
            const additional_mc0 = this.header?.BoQ_ADDITIONAL_MC0 || [];
            const additional_mc_between = this.header?.BoQ_ADDITIONAL_MC_BETWEEN || [];
            const additional_mc100 = this.header?.BoQ_ADDITIONAL_MC100 || [];
            
            const result = [];

            // Main scope section
            result.push({ isTypeHeader: true, Type: this.$BOQ_TYPE.MAIN_SCOPE });
            main.forEach(item => {
                item.Type = this.$BOQ_TYPE.MAIN_SCOPE; 
                item.isTypeHeader = false;
                result.push(item); 
            });

            // Additional scope section
            result.push({ isTypeHeader: true, Type: this.$BOQ_TYPE.ADDITIONAL_SCOPE_MC0 });
            additional_mc0 .forEach(item => {
                item.Type = this.$BOQ_TYPE.ADDITIONAL_SCOPE_MC0;
                item.isTypeHeader = false;
                result.push(item);
            });
            result.push({ isTypeHeader: true, Type: this.$BOQ_TYPE.ADDITIONAL_SCOPE_MC_BETWEEN });
            additional_mc_between.forEach(item => {
                item.Type = this.$BOQ_TYPE.ADDITIONAL_SCOPE_MC_BETWEEN;
                item.isTypeHeader = false;
                result.push(item);
            });
            result.push({ isTypeHeader: true, Type: this.$BOQ_TYPE.ADDITIONAL_SCOPE_MC100 });
            additional_mc100.forEach(item => {
                item.Type = this.$BOQ_TYPE.ADDITIONAL_SCOPE_MC100;
                item.isTypeHeader = false;
                result.push(item);
            });
           // --- TOTAL AMOUNT (Main + Additional) --
            //Total Amount & Final Total Amount di-hide untuk user tanpa otorisasi view RKTK
            if (!this.canViewRKTK) return result;

            const totalData = this.totalMainAmount();
            const mergedTotals = totalData.reduce((acc, curr) => ({ ...acc, ...curr }), {});
            const totalRow = {
            isTotalRow: true,
            Description_Total: this.$t('Total_Amount'),
            };
            for (const [key, value] of Object.entries(mergedTotals)) {
                totalRow[key] = value ?? 0;
            }
            result.push(totalRow);
            // --- FINAL TOTAL MAIN ---
            result.push({
                isFinalTotalRow: true,
                Description_Total: this.$t('Final_Total_Amount'),
                MC0_Contract_Amount : this.header?.Main_Contract_MC0 || 0,
                MCBetween_Contract_Amount : this.header?.Main_Contract_MC_Between || 0,
                MC100_Contract_Amount : this.header?.Main_Contract_MC100 || 0
            });

            return result;
        },
        boqAddendum(){
            const base = this.header?.BoQ_MC0 || [];
            const result = [...base];

            //Total Amount & Final Total Amount di-hide untuk user tanpa otorisasi view RKTK
            if (!this.canViewRKTK) return result;

            const totalData = this.totalAddendum_MC0_Amount();
            const mergedTotals = totalData.reduce((acc, curr) => ({ ...acc, ...curr }), {});

            const totalRow = {
                isTotalRow: true,
                Description_Total: this.$t('Total_Amount'),
            };

            for (const [key, value] of Object.entries(mergedTotals)) {
                totalRow[key] = value ?? 0;
            }

            result.push(totalRow);
            result.push({
                isFinalTotalRow: true,
                Description_Total: this.$t('Final_Total_Amount'),
                MC0_Contract_Amount : this.header?.Addendum_MC0_Contract_MC0 || 0,
                MCBetween_Contract_Amount : this.header?.Addendum_MC0_Between_Contract_MC_Between || 0,
                MC100_Contract_Amount : this.header?.Addendum_MC0_Contract_MC100 || 0
            });
            
             return result;
        },
        boqAddendumMCBetween(){
            const base = this.header?.BoQ_MC_BETWEEN || [];
            const result = [...base];

            //Total Amount & Final Total Amount di-hide untuk user tanpa otorisasi view RKTK
            if (!this.canViewRKTK) return result;

            const totalData = this.totalAddendum_MC_BETWEEN_Amount();
            const mergedTotals = totalData.reduce((acc, curr) => ({ ...acc, ...curr }), {});

            const totalRow = {
                isTotalRow: true,
                Description_Total: this.$t('Total_Amount'),
            };

            for (const [key, value] of Object.entries(mergedTotals)) {
                totalRow[key] = value ?? 0;
            }

            result.push(totalRow);
            result.push({
                isFinalTotalRow: true,
                Description_Total: this.$t('Final_Total_Amount'),
                MC0_Contract_Amount : this.header?.Addendum_MC_Between_Contract_MC0 || 0,
                MCBetween_Contract_Amount : this.header?.Addendum_MC_Between_Contract_MC_Between || 0,
                MC100_Contract_Amount : this.header?.Addendum_MC_Between_Contract_MC100 || 0
            });
            
             return result;
        },
        boqAddendumMC100(){
            const base = this.header?.BoQ_MC100 || [];
            const result = [...base];

            //Total Amount & Final Total Amount di-hide untuk user tanpa otorisasi view RKTK
            if (!this.canViewRKTK) return result;

            const totalData = this.totalAddendum_MC100_Amount();
            const mergedTotals = totalData.reduce((acc, curr) => ({ ...acc, ...curr }), {});

            const totalRow = {
                isTotalRow: true,
                Description_Total: this.$t('Total_Amount'),
            };

            for (const [key, value] of Object.entries(mergedTotals)) {
                totalRow[key] = value ?? 0;
            }

            result.push(totalRow);
            result.push({
                isFinalTotalRow: true,
                Description_Total: this.$t('Final_Total_Amount'),
                MC0_Contract_Amount : this.header?.Addendum_MC100_Contract_MC0 || 0,
                MCBetween_Contract_Amount : this.header?.Addendum_MC100_Contract_MC_Between || 0,
                MC100_Contract_Amount : this.header?.Addendum_MC100_Contract_MC100 || 0
            });
            
             return result;
        },
    },
    methods:
    {

        totalMainAmount() {
            const main = this.header?.BoQ_MAIN || [];
            const additional_mc0 = this.header?.BoQ_ADDITIONAL_MC0 || [];
            const additional_mc_between = this.header?.BoQ_ADDITIONAL_MC_BETWEEN || [];
            const additional_mc100 = this.header?.BoQ_ADDITIONAL_MC100 || [];
            const fields = [
                "Initial_Contract_Amount",
                "RKTK_MC0_Amount",
                "RKTK_MCBetween_Amount",
                "RKTK_MC100_Amount",
                "MC0_Contract_Amount",
                "MCBetween_Contract_Amount",
                "MC100_Contract_Amount",
                "Temp_Adjust_Contract_Amount",
            ];
            return fields.map(field => {
                const totalMain = main.reduce((sum, item) => sum + (parseFloat(item[field]) || 0), 0);
                const totalAdditional_mc0 = additional_mc0.reduce((sum, item) => sum + (parseFloat(item[field]) || 0), 0);
                const totalAdditional_mc_between = additional_mc_between.reduce((sum, item) => sum + (parseFloat(item[field]) || 0), 0);
                const totalAdditional_mc100 = additional_mc100.reduce((sum, item) => sum + (parseFloat(item[field]) || 0), 0);
                return { [field]: Math.round(totalMain + totalAdditional_mc0 + totalAdditional_mc_between + totalAdditional_mc100) };
            });
        },
        totalAddendum_MC0_Amount() {
            const main = this.header?.BoQ_MC0 || [];
            const fields = [
                "Initial_Contract_Amount",
                "RKTK_MC0_Amount",
                "RKTK_MCBetween_Amount",
                "RKTK_MC100_Amount",
                "MC0_Contract_Amount",
                "MCBetween_Contract_Amount",
                "MC100_Contract_Amount",
                "Temp_Adjust_Contract_Amount",
            ];
            return fields.map(field => {
                const totalMain = main.reduce((sum, item) => sum + (parseFloat(item[field]) || 0), 0);
                return { [field]: Math.round(totalMain) };
            });
        },
        totalAddendum_MC_BETWEEN_Amount() {
            const main = this.header?.BoQ_MC_BETWEEN || [];
            const fields = [
                "Initial_Contract_Amount",
                "RKTK_MC0_Amount",
                "RKTK_MCBetween_Amount",
                "RKTK_MC100_Amount",
                "MC0_Contract_Amount",
                "MCBetween_Contract_Amount",
                "MC100_Contract_Amount",
                "Temp_Adjust_Contract_Amount",
            ];
            return fields.map(field => {
                const totalMain = main.reduce((sum, item) => sum + (parseFloat(item[field]) || 0), 0);
                return { [field]: Math.round(totalMain) };
            });
        },
        totalAddendum_MC100_Amount() {
            const main = this.header?.BoQ_MC100 || [];
            const fields = [
                "Initial_Contract_Amount",
                "RKTK_MC0_Amount",
                "RKTK_MCBetween_Amount",
                "RKTK_MC100_Amount",
                "MC0_Contract_Amount",
                "MCBetween_Contract_Amount",
                "MC100_Contract_Amount",
                "Temp_Adjust_Contract_Amount",
            ];
            return fields.map(field => {
                const totalMain = main.reduce((sum, item) => sum + (parseFloat(item[field]) || 0), 0);
                return { [field]: Math.round(totalMain) };
            });
        },
        onPriceOrVolumeChange(e, row, fieldName) {
            const newVal = (typeof e?.valueNumber === 'number') ? e.valueNumber : (e?.value !== undefined ? Number(e.value) : NaN);
            if (fieldName) {
                // Only assign when the parsed value is a finite number (prevents storing NaN when user types '-')
                if (Number.isFinite(newVal)) {
                    row[fieldName] = newVal;
                } else if (e?.type === 'blur') {
                    // On blur, if input is invalid (e.g. lone '-') normalize to 0
                    row[fieldName] = 0;
                }
            }
            const material = Number(row.Material_Price ?? 0);
            const labour   = Number(row.Labour_Price ?? 0);
            const initialMaterial = Number(this.initialMaterialPrice(row) ?? 0);
            const initialLabour   = Number(this.initialLabourPrice(row) ?? 0);
            const volume   = Number(row.Initial_Contract_Volume ?? 0);
            const volume_Adjust   = Number(row.Temp_Adjust_Contract_Volume ?? 0);

            const total = this.truncateDecimal((initialMaterial + initialLabour) * volume, 4);
            const total_Adjust = this.truncateDecimal((material + labour) * volume_Adjust, 4);
            if(!row.DoneAddendum){
                row.Initial_Contract_Amount = Number.isFinite(total) ? total : 0;
            }           
            row.Temp_Adjust_Contract_Amount = Number.isFinite(total_Adjust) ? total_Adjust : 0;
            if (this.header?.ScopeMain?.length) {
                this.header.Total_Initial_Contract = this.header.ScopeMain
                .reduce((s, r) => s + (Number(r.Initial_Contract_Amount) || 0), 0);
                this.header.Total_Adjust_Contract = this.header.ScopeMain
                .reduce((s, r) => s + (Number(r.Temp_Adjust_Contract_Amount) || 0), 0);
            }
        },
        truncateDecimal(value, decimalPlaces = 4) {
            const factor = Math.pow(10, decimalPlaces);
            return Math.trunc(value * factor) / factor;
        },
        initialMaterialPrice(row) {
            // Belum ada data (null di DB), mirror Updated (Latest)
            return row?.Initial_Material_Price ?? row?.Material_Price ?? null;
        },
        initialLabourPrice(row) {
            // Belum ada data (null di DB), mirror Updated (Latest)
            return row?.Initial_Labour_Price ?? row?.Labour_Price ?? null;
        },
        percentBobot(row, rows) {
            if (String(row?.Section_Type?.Value ?? row?.Section_Type ?? '').toLowerCase() === 'section') return null;
            //Row Total tidak dirender untuk user tanpa otorisasi view RKTK, jadi total dihitung ulang dari data row
            const total = (rows || []).reduce((sum, r) =>
                (r.isTypeHeader || r.isTotalRow || r.isFinalTotalRow)
                    ? sum
                    : sum + (Number(r.Initial_Contract_Amount) || 0), 0);
            if (!total) return null;
            return this.truncateDecimal(((Number(row?.Initial_Contract_Amount) || 0) / total) * 100, 2);
        },
        percentBobotAddendum(row) {
            const rows = [this.boqAddendum, this.boqAddendumMCBetween, this.boqAddendumMC100]
                .find(list => list.includes(row));
            return this.percentBobot(row, rows);
        },
        hideRow(data) {
                return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
            },
        onTypeBoQChange(data) {
            // Reset fields saat Section_Type berubah
            data.Unit = null;
            data.Material_Price = null;
            data.Labour_Price = null;
            data.Initial_Contract_Volume = null;
            data.Initial_Contract_Amount = null;
            
            // Call the original edit complete handler
            this.onCellEditCompleteBoQ(data);
        },
        addBoQ(type) {

            if (type !== this.$BOQ_TYPE.MAIN_SCOPE) return;

            if (!this.header || !this.header.BoQ_MAIN) {
                this.header.BoQ_MAIN = [];
            }

            // pastikan template data bukan reference langsung
            const newDetail = { ...this.boq_main };
            newDetail.mode = this.$FORM_MODE_CREATE;
            newDetail.Type = this.$BOQ_TYPE.MAIN_SCOPE;
            newDetail.Amount = 0;
            newDetail.isTypeHeader = false;

            this.header.BoQ_MAIN.push(newDetail);
        },

        deleteBoQ(item, type) {
            if (!item || !type) return;

                let targetArray;

                if (type === this.$BOQ_TYPE.MAIN_SCOPE) {
                    targetArray = this.header.BoQ_MAIN;
                } else if (type === this.$BOQ_TYPE.ADDITIONAL_SCOPE_MC0) {
                    targetArray = this.header.BoQ_ADDITIONAL_MC0;
                } else if (type === this.$BOQ_TYPE.ADDITIONAL_SCOPE_MC_BETWEEN){
                    targetArray = this.header.BoQ_ADDITIONAL_MC_BETWEEN;
                } else if (type === this.$BOQ_TYPE.ADDITIONAL_SCOPE_MC100){
                    targetArray = this.header.BoQ_ADDITIONAL_MC100;
                } else {
                    targetArray = [];
                }

            const idx = targetArray.indexOf(item);
            if (idx !== -1) {
              
                if (targetArray[idx].mode === this.$FORM_MODE_CREATE) {
                    targetArray.splice(idx, 1);
                } else {
                    targetArray[idx].mode = this.$FORM_MODE_DELETE;
                    // targetArray.splice(idx, 1);
                }
            }
        },
        onCellEditCompleteBoQ(data) 
        {                  
                let targetArray;

                if (data.Type === this.$BOQ_TYPE.MAIN_SCOPE) {
                    targetArray = this.header.BoQ_MAIN;
                } else if (data.Type === this.$BOQ_TYPE.ADDITIONAL_SCOPE_MC0) {
                    targetArray = this.header.BoQ_ADDITIONAL_MC0;
                } else if (data.Type === this.$BOQ_TYPE.ADDITIONAL_SCOPE_MC_BETWEEN){
                    targetArray = this.header.BoQ_ADDITIONAL_MC_BETWEEN;
                } 
                else if (data.Type === this.$BOQ_TYPE.ADDITIONAL_SCOPE_MC100)
                {
                    targetArray = this.header.BoQ_ADDITIONAL_MC100;
                } 
                else if (data.Type === this.$BOQ_TYPE.ADDENDUM_MC0) {
                    targetArray = this.header.BoQ_MC0;
                } 
                else if (data.Type === this.$BOQ_TYPE.ADDENDUM_MC_BETWEEN) {
                    targetArray = this.header.BoQ_MC_BETWEEN;
                } 
                else if (data.Type === this.$BOQ_TYPE.ADDENDUM_MC100)
                {
                    targetArray = this.header.BoQ_MC100;
                } 
                else {
                    targetArray = [];
                }

             let mode = data.mode;
             const idx = targetArray.indexOf(data);       
             if(targetArray[idx])
             {
                if (mode == this.$FORM_MODE_UNCHANGED)
                    targetArray[idx].mode = this.$FORM_MODE_EDIT;
             }

        },
        editBoQ(type, index) {
                let targetArray;

                if (type === this.$BOQ_TYPE.MAIN_SCOPE) {
                    targetArray = this.header.BoQ_MAIN;
                } else if (type === this.$BOQ_TYPE.ADDITIONAL_SCOPE_MC0) {
                    targetArray = this.header.BoQ_ADDITIONAL_MC0;
                } else if (type === this.$BOQ_TYPE.ADDITIONAL_SCOPE_MC_BETWEEN){
                    targetArray = this.header.BoQ_ADDITIONAL_MC_BETWEEN;
                } else if (type === this.$BOQ_TYPE.ADDITIONAL_SCOPE_MC100){
                    targetArray = this.header.BoQ_ADDITIONAL_MC100;
                } else {
                    targetArray = [];
                }
            if (targetArray && targetArray[index]) {
                let mode = targetArray[index].mode;
                if (mode == this.$FORM_MODE_UNCHANGED)
                targetArray[index].mode = this.$FORM_MODE_EDIT;
            }
            
        },
        // File upload methods
        onFileSelect(event) {
            const file = event.target.files[0];
            if (file) {
                // Validate file type - hanya Excel
                const validExtensions = ['xlsx', 'xls'];
                const fileExtension = file.name.split('.').pop().toLowerCase();
                
                if (!validExtensions.includes(fileExtension)) {
                    this.uploadMessage = 'Format file tidak valid. Silakan pilih file Excel (.xlsx atau .xls).';
                    this.uploadMessageType = 'error';
                    this.selectedFile = null;
                    event.target.value = '';
                    return;
                }

                // Validate file size (max 10MB)
                if (file.size > 10 * 1024 * 1024) {
                    this.uploadMessage = 'Ukuran file terlalu besar. Maksimal 10MB.';
                    this.uploadMessageType = 'error';
                    this.selectedFile = null;
                    event.target.value = '';
                    return;
                }

                this.selectedFile = file;
                this.uploadMessage = '';
                this.uploadMessageType = 'info';
            }
        },
        async uploadFile() {
            if (!this.selectedFile) {
                this.uploadMessage = 'Please select a file first.';
                this.uploadMessageType = 'warn';
                return;
            }

            try {
                this.isUploading = true;
                this.uploadMessage = 'Uploading file...';
                this.uploadMessageType = 'info';

                const formData = new FormData();
                formData.append('attachments.File', this.selectedFile, this.selectedFile.name);
                
                // Tambahkan Id header jika ada
                if (this.header?.Id) {
                    formData.append('Id', this.header.Id);
                }

                // Get token from store
                const token = this.$store.state.token?.Token || '';
                const language = this.$store.state.token?.Language || 'id';

                // Upload file ke server
                const response = await fetch(this.url + 'uploadFile', {
                    method: 'POST',
                    headers: {
                        'Authorization': token,
                        'language': language
                    },
                    body: formData
                });

                if (!response.ok) {
                    throw new Error('Upload failed: ' + response.statusText);
                }

                const result = await response.json();
            
                if (result.success) {
                    this.uploadMessage = 'File successfully uploaded and imported!';
                    this.uploadMessageType = 'success';
                    
                    if (result.data && result.data.header && result.data.header.BoQ_MAIN) {
                        const importedData = result.data.header.BoQ_MAIN;
                    
                    
                        const processedData = importedData.map(item => ({
                            ...item,
                            No_BoQ: item.No_BoQ != null ? String(item.No_BoQ) : '',
                            mode: this.$FORM_MODE_CREATE,
                            Type: this.$BOQ_TYPE.MAIN_SCOPE,
                            isTypeHeader: false
                        }));
                        
                        this.header.BoQ_MAIN = processedData;
                        this.header.uploadTemplate = result.data.header.uploadTemplate;
                        
                    }              
                    // Clear file input after success
                    this.selectedFile = null;
                    if (this.$refs.fileInput) {
                        this.$refs.fileInput.value = '';
                    }
                } else {
                    throw new Error(result.message || 'Upload Failed');
                }
            } catch (error) {
                this.uploadMessage = 'Error: ' + error.message;
                this.uploadMessageType = 'error';
            } finally {
                this.isUploading = false;
            }
        },
        processImportedData(data) {
            // Process imported data dan masukkan ke BoQ_MAIN
            if (!this.header) {
                this.header = {};
            }
            if (!this.header.BoQ_MAIN) {
                this.header.BoQ_MAIN = [];
            }

            data.forEach(item => {
                const newDetail = {
                    ...this.boq_main,
                    mode: this.$FORM_MODE_CREATE,
                    Type: this.$BOQ_TYPE.MAIN_SCOPE,
                    isTypeHeader: false,
                    Section_Type: item.Section_Type || null,
                    No_BoQ: item.No_BoQ != null ? String(item.No_BoQ) : '',
                    Scope: item.Scope || '',
                    Unit: item.Unit || '',
                    Material_Price: parseFloat(item.Material_Price) || 0,
                    Labour_Price: parseFloat(item.Labour_Price) || 0,
                    Initial_Contract_Volume: parseFloat(item.Initial_Contract_Volume) || 0,
                    Initial_Contract_Amount: 0
                };

                // Calculate amount
                newDetail.Initial_Contract_Amount = 
                    (newDetail.Material_Price + newDetail.Labour_Price) * 
                    newDetail.Initial_Contract_Volume;

                this.header.BoQ_MAIN.push(newDetail);
            });
        },
    }
}
</script>
<style>
.sticky-header {
  position: sticky;
  top: 0;
  background: white;
  z-index: 10;
  padding: 0.5rem;
}

/* Card Header Sticky - Only for BoQ Cards */
.card-header-title {
  padding: 1rem;
  background: #f8f9fa;
  font-weight: 600;
  display: block;
}

.boq-card.p-card .p-card-header {
  padding: 0 !important;
  background: #f8f9fa !important;
  border-bottom: 2px solid #dee2e6 !important;
  order: -1 !important;
}

.boq-card.p-card .p-card-body {
  padding-top: 0;
  order: 0 !important;
}

.boq-card.p-card > .p-card-body {
  display: flex;
  flex-direction: column;
}

.boq-card.p-card > .p-card-body > .p-card-content {
  order: 1;
}

/* Table wrapper with fixed header */
.table-wrapper-fixed-header {
  max-height: 60vh;
  overflow-y: auto;
  overflow-x: auto;
  position: relative;
}

.table-wrapper-fixed-header .table-fixed-header {
  width: 100%;
}

.table-wrapper-fixed-header .table-fixed-header :deep(thead.p-datatable-thead) {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.table-wrapper-fixed-header .table-fixed-header :deep(thead.p-datatable-thead tr) {
  background-color: #ffffff !important;
}

.table-wrapper-fixed-header .table-fixed-header :deep(thead.p-datatable-thead tr th) {
  background-color: #ffffff !important;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 100;
}

/* Sticky columns di header dengan z-index lebih tinggi */
.table-wrapper-fixed-header .table-fixed-header :deep(thead.p-datatable-thead tr th.sticky-col-0-header),
.table-wrapper-fixed-header .table-fixed-header :deep(thead.p-datatable-thead tr th.sticky-col-1-header),
.table-wrapper-fixed-header .table-fixed-header :deep(thead.p-datatable-thead tr th.sticky-col-2-header),
.table-wrapper-fixed-header .table-fixed-header :deep(thead.p-datatable-thead tr th.sticky-col-3-header),
.table-wrapper-fixed-header .table-fixed-header :deep(thead.p-datatable-thead tr th.sticky-col-4-header),
.table-wrapper-fixed-header .table-fixed-header :deep(thead.p-datatable-thead tr th.sticky-col-5-header),
.table-wrapper-fixed-header .table-fixed-header :deep(thead.p-datatable-thead tr th.sticky-col-6-header),
.table-wrapper-fixed-header .table-fixed-header :deep(thead.p-datatable-thead tr th.sticky-col-7-header) {
  z-index: 101 !important;
}

.table-wrapper-fixed-header .table-fixed-header :deep(thead.p-datatable-thead tr th.sticky-col-0-header-addendum),
.table-wrapper-fixed-header .table-fixed-header :deep(thead.p-datatable-thead tr th.sticky-col-1-header-addendum),
.table-wrapper-fixed-header .table-fixed-header :deep(thead.p-datatable-thead tr th.sticky-col-2-header-addendum),
.table-wrapper-fixed-header .table-fixed-header :deep(thead.p-datatable-thead tr th.sticky-col-3-header-addendum),
.table-wrapper-fixed-header .table-fixed-header :deep(thead.p-datatable-thead tr th.sticky-col-4-header-addendum),
.table-wrapper-fixed-header .table-fixed-header :deep(thead.p-datatable-thead tr th.sticky-col-5-header-addendum) {
  z-index: 101 !important;
}

.editable-cells-table >>> .p-datatable-thead > tr > th.sticky-col-0-header-addendum,
.editable-cells-table >>> .p-datatable-thead > tr > th.sticky-col-1-header-addendum,
.editable-cells-table >>> .p-datatable-thead > tr > th.sticky-col-2-header-addendum,
.editable-cells-table >>> .p-datatable-thead > tr > th.sticky-col-3-header-addendum,
.editable-cells-table >>> .p-datatable-thead > tr > th.sticky-col-4-header-addendum,
.editable-cells-table >>> .p-datatable-thead > tr > th.sticky-col-5-header-addendum {
  z-index: 3 !important;
}

.p-datatable.custom-boq-table .p-datatable-tbody > tr {
  display: flex;             
  align-items: stretch;      
}
.p-datatable.custom-boq-table .p-datatable-tbody > tr > td {
  display: flex;
  align-items: center;
  overflow: visible;        
  border-bottom: 1px solid #e0e0e0;
}

.sticky-col-0, .sticky-col-0-header { position: sticky; left: 0; z-index: 5; background: white; min-width: 50px; border-right: 1px solid #ccc; }
.sticky-col-1, .sticky-col-1-header { position: sticky; left: 50px; z-index: 5; background: white; min-width: 100px; border-right: 1px solid #ccc; }
.sticky-col-2, .sticky-col-2-header { position: sticky; left: 150px; z-index: 5; background: white; min-width: 130px; border-right: 1px solid #ccc; }
.sticky-col-3, .sticky-col-3-header { position: sticky; left: 280px; z-index: 5; background: white; min-width: 150px; border-right: 1px solid #ccc; }
.sticky-col-4, .sticky-col-4-header { position: sticky; left: 430px; z-index: 5; background: white; min-width: 200px; border-right: 1px solid #ccc; }
.sticky-col-5, .sticky-col-5-header { position: sticky; left: 630px; z-index: 5; background: white; min-width: 150px; border-right: 1px solid #ccc; }
.sticky-col-6, .sticky-col-6-header { position: sticky; left: 780px; z-index: 5; background: white; min-width: 150px; border-right: 1px solid #ccc; }
.sticky-col-7, .sticky-col-7-header { position: sticky; left: 930px; z-index: 5; background: white; min-width: 150px; border-right: 1px solid #ccc; }
.column-min-width {
  width: 150px;
  min-width: 150px;
}
.p-datatable textarea {
  width: 100%;
  resize: vertical;          /* bisa di-drag ke atas/bawah */
  min-height: 38px;
  overflow-y: auto;
  box-sizing: border-box;
}
.sticky-col-0-addendum, .sticky-col-0-header-addendum { position: sticky; left: 0; z-index: 5; background: white; min-width: 130px; border-right: 1px solid #ccc; }
.sticky-col-1-addendum, .sticky-col-1-header-addendum { position: sticky; left: 130px; z-index: 5; background: white; min-width: 150px; border-right: 1px solid #ccc; }
.sticky-col-2-addendum, .sticky-col-2-header-addendum { position: sticky; left: 280px; z-index: 5; background: white; min-width: 200px; border-right: 1px solid #ccc; }
.sticky-col-3-addendum, .sticky-col-3-header-addendum { position: sticky; left: 480px; z-index: 5; background: white; min-width: 150px; border-right: 1px solid #ccc; }
.sticky-col-4-addendum, .sticky-col-4-header-addendum { position: sticky; left: 630px; z-index: 5; background: white; min-width: 150px; border-right: 1px solid #ccc; }
.sticky-col-5-addendum, .sticky-col-5-header-addendum { position: sticky; left: 780px; z-index: 5; background: white; min-width: 150px; border-right: 1px solid #ccc; }

/* Sticky Header Styles - moved to global style below */

/* Upload Card Styling */
.upload-card {
    margin-bottom: 1rem;
    border: 1px solid #dee2e6;
    background: #ffffff;
    max-width: 50%;
    width: fit-content;
}

.upload-card .p-card-content {
    padding: 0.75rem !important;
}

.upload-container {
    padding: 0;
}

.upload-header {
    margin-bottom: 0.5rem;
}

.upload-title {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    color: #495057;
}

.upload-body {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap;
}

.file-input-wrapper {
    flex: 1;
    min-width: 200px;
}

.file-input-wrapper input[type="file"] {
    display: none;
}

.file-input-label {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.4rem 0.75rem;
    background: #f8f9fa;
    border: 1px solid #ced4da;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #495057;
    font-size: 0.875rem;
    width: 100%;
}

.file-label-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.file-input-label i {
    color: #28a745;
    flex-shrink: 0;
}

.file-input-label:hover {
    border-color: #28a745;
    background: #f0fff4;
}

.upload-btn {
    min-width: 90px;
}

.upload-message {
    margin-top: 0.5rem;
}

.upload-message small {
    display: flex;
    align-items: center;
    gap: 0.35rem;
    font-size: 0.8rem;
    padding: 0.35rem 0.5rem;
    border-radius: 3px;
}

.message-success {
    color: #28a745;
    background: #d4edda;
}

.message-error {
    color: #dc3545;
    background: #f8d7da;
}

.message-warn {
    color: #ffc107;
    background: #fff3cd;
}

.message-info {
    color: #17a2b8;
    background: #d1ecf1;
}

/* Disabled state */
.file-input-wrapper input[type="file"]:disabled + .file-input-label {
    opacity: 0.6;
    cursor: not-allowed;
    background: #e9ecef;
}

.file-input-wrapper input[type="file"]:disabled + .file-input-label:hover {
    border-color: #ced4da;
    background: #e9ecef;
}
</style>

<style>
/* Global Sticky Header Styles - not scoped */
.table-wrapper-fixed-header {
  position: relative;
  max-height: 60vh;
  overflow-y: auto;
  overflow-x: auto;
}

.table-wrapper-fixed-header .p-datatable-wrapper {
  overflow: visible !important;
}

.table-wrapper-fixed-header .p-datatable-thead {
  position: -webkit-sticky !important;
  position: sticky !important;
  top: 0 !important;
  z-index: 101 !important;
  background-color: #ffffff !important;
}

.table-wrapper-fixed-header .p-datatable-thead tr {
  background-color: #ffffff !important;
}

.table-wrapper-fixed-header .p-datatable-thead tr:nth-child(1) th {
  position: -webkit-sticky !important;
  position: sticky !important;
  top: 0 !important;
  z-index: 50 !important;
  background-color: #ffffff !important;
  border-bottom: 1px solid #e9ecef;
  padding: 0.5rem 1rem;
}

.table-wrapper-fixed-header .p-datatable-thead tr:nth-child(2) th {
  position: -webkit-sticky !important;
  position: sticky !important;
  top: 35px !important;
  z-index: 50 !important;
  background-color: #ffffff !important;
  border-bottom: 2px solid #dee2e6;
  padding: 0.5rem 1rem;
}

.table-wrapper-fixed-header .p-datatable-thead tr th {
  background-color: #ffffff !important;
}

/* Sticky columns horizontally - Action to Unit (columns 1-6) - ONLY for main boqCombined table */
/* Header sticky columns - Row 1 only (has rowspan) */
.table-wrapper-fixed-header .p-datatable:not(.boq-addendum-table) .p-datatable-thead tr:nth-child(1) th:nth-child(1),
.table-wrapper-fixed-header .p-datatable:not(.boq-addendum-table) .p-datatable-thead tr:nth-child(1) th:nth-child(2),
.table-wrapper-fixed-header .p-datatable:not(.boq-addendum-table) .p-datatable-thead tr:nth-child(1) th:nth-child(3),
.table-wrapper-fixed-header .p-datatable:not(.boq-addendum-table) .p-datatable-thead tr:nth-child(1) th:nth-child(4),
.table-wrapper-fixed-header .p-datatable:not(.boq-addendum-table) .p-datatable-thead tr:nth-child(1) th:nth-child(5),
.table-wrapper-fixed-header .p-datatable:not(.boq-addendum-table) .p-datatable-thead tr:nth-child(1) th:nth-child(6) {
  position: sticky !important;
  z-index: 200 !important;
  background-color: #ffffff !important;
}

.table-wrapper-fixed-header .p-datatable:not(.boq-addendum-table) .p-datatable-thead tr:nth-child(1) th:nth-child(1) { left: 0 !important; width: 80px !important; min-width: 80px !important; }
.table-wrapper-fixed-header .p-datatable:not(.boq-addendum-table) .p-datatable-thead tr:nth-child(1) th:nth-child(2) { left: 80px !important; width: 100px !important; min-width: 100px !important; }
.table-wrapper-fixed-header .p-datatable:not(.boq-addendum-table) .p-datatable-thead tr:nth-child(1) th:nth-child(3) { left: 180px !important; width: 80px !important; min-width: 80px !important; }
.table-wrapper-fixed-header .p-datatable:not(.boq-addendum-table) .p-datatable-thead tr:nth-child(1) th:nth-child(4) { left: 260px !important; width: 150px !important; min-width: 150px !important; }
.table-wrapper-fixed-header .p-datatable:not(.boq-addendum-table) .p-datatable-thead tr:nth-child(1) th:nth-child(5) { left: 410px !important; width: 350px !important; min-width: 350px !important; }
.table-wrapper-fixed-header .p-datatable:not(.boq-addendum-table) .p-datatable-thead tr:nth-child(1) th:nth-child(6) {
  left: 760px !important;
  width: 100px !important;
  min-width: 100px !important;
  box-shadow: 3px 0 5px -2px rgba(0,0,0,0.15) !important;
}

/* Non-sticky header columns - must have lower z-index */
.table-wrapper-fixed-header .p-datatable:not(.boq-addendum-table) .p-datatable-thead tr:nth-child(1) th:nth-child(n+7) {
  z-index: 50 !important;
}

/* Row 2 doesn't have the first 6 columns (they use rowspan from row 1) */
/* So all th in row 2 should have low z-index */
.table-wrapper-fixed-header .p-datatable:not(.boq-addendum-table) .p-datatable-thead tr:nth-child(2) th {
  z-index: 50 !important;
}

/* Body sticky columns - ONLY for main boqCombined table */
.table-wrapper-fixed-header .p-datatable:not(.boq-addendum-table) .p-datatable-tbody tr td:nth-child(1),
.table-wrapper-fixed-header .p-datatable:not(.boq-addendum-table) .p-datatable-tbody tr td:nth-child(2),
.table-wrapper-fixed-header .p-datatable:not(.boq-addendum-table) .p-datatable-tbody tr td:nth-child(3),
.table-wrapper-fixed-header .p-datatable:not(.boq-addendum-table) .p-datatable-tbody tr td:nth-child(4),
.table-wrapper-fixed-header .p-datatable:not(.boq-addendum-table) .p-datatable-tbody tr td:nth-child(5),
.table-wrapper-fixed-header .p-datatable:not(.boq-addendum-table) .p-datatable-tbody tr td:nth-child(6) {
  position: sticky !important;
  z-index: 99 !important;
  background-color: #ffffff !important;
}

.table-wrapper-fixed-header .p-datatable:not(.boq-addendum-table) .p-datatable-tbody tr td:nth-child(1) { left: 0 !important; width: 80px !important; min-width: 80px !important; }
.table-wrapper-fixed-header .p-datatable:not(.boq-addendum-table) .p-datatable-tbody tr td:nth-child(2) { left: 80px !important; width: 100px !important; min-width: 100px !important; }
.table-wrapper-fixed-header .p-datatable:not(.boq-addendum-table) .p-datatable-tbody tr td:nth-child(3) { left: 180px !important; width: 80px !important; min-width: 80px !important; }
.table-wrapper-fixed-header .p-datatable:not(.boq-addendum-table) .p-datatable-tbody tr td:nth-child(4) { left: 260px !important; width: 150px !important; min-width: 150px !important; }
.table-wrapper-fixed-header .p-datatable:not(.boq-addendum-table) .p-datatable-tbody tr td:nth-child(5) { left: 410px !important; width: 350px !important; min-width: 350px !important; }
.table-wrapper-fixed-header .p-datatable:not(.boq-addendum-table) .p-datatable-tbody tr td:nth-child(6) {
  left: 760px !important;
  width: 100px !important;
  min-width: 100px !important;
  box-shadow: 3px 0 5px -2px rgba(0,0,0,0.15) !important;
}

/* Non-sticky body columns - lower z-index */
.table-wrapper-fixed-header .p-datatable:not(.boq-addendum-table) .p-datatable-tbody tr td:nth-child(n+7) {
  z-index: 1 !important;
}

/* BoQ Addendum table column width control */
::v-deep(.boq-addendum-table .p-datatable-thead tr th:nth-child(1)),
::v-deep(.boq-addendum-table .p-datatable-tbody tr td:nth-child(1)) {
    width: 80px !important;
    min-width: 80px !important;
    max-width: 80px !important;
}

::v-deep(.boq-addendum-table .p-datatable-thead tr th:nth-child(3)),
::v-deep(.boq-addendum-table .p-datatable-tbody tr td:nth-child(3)) {
    width: 350px !important;
    min-width: 350px !important;
    max-width: 350px !important;
}

/* BoQ Addendum Table Sticky Columns */
/* Header sticky columns for addendum (4 columns: type, no, scope, unit) */
.boq-addendum-table .p-datatable-thead tr:nth-child(1) th:nth-child(1),
.boq-addendum-table .p-datatable-thead tr:nth-child(1) th:nth-child(2),
.boq-addendum-table .p-datatable-thead tr:nth-child(1) th:nth-child(3),
.boq-addendum-table .p-datatable-thead tr:nth-child(1) th:nth-child(4) {
  position: sticky !important;
  z-index: 200 !important;
  background-color: #ffffff !important;
}

.boq-addendum-table .p-datatable-thead tr:nth-child(1) th:nth-child(1) { left: 0 !important; width: 80px !important; min-width: 80px !important; }
.boq-addendum-table .p-datatable-thead tr:nth-child(1) th:nth-child(2) { left: 80px !important; width: 150px !important; min-width: 150px !important; }
.boq-addendum-table .p-datatable-thead tr:nth-child(1) th:nth-child(3) { left: 230px !important; width: 350px !important; min-width: 350px !important; }
.boq-addendum-table .p-datatable-thead tr:nth-child(1) th:nth-child(4) {
  left: 580px !important;
  width: 100px !important;
  min-width: 100px !important;
  box-shadow: 3px 0 5px -2px rgba(0,0,0,0.15) !important;
}

/* Non-sticky header columns for addendum - must have lower z-index */
.boq-addendum-table .p-datatable-thead tr:nth-child(1) th:nth-child(n+5),
.boq-addendum-table .p-datatable-thead tr:nth-child(2) th {
  z-index: 50 !important;
  background-color: #ffffff !important;
}

/* Body sticky columns for addendum */
.boq-addendum-table .p-datatable-tbody tr td:nth-child(1),
.boq-addendum-table .p-datatable-tbody tr td:nth-child(2),
.boq-addendum-table .p-datatable-tbody tr td:nth-child(3),
.boq-addendum-table .p-datatable-tbody tr td:nth-child(4) {
  position: sticky !important;
  z-index: 99 !important;
  background-color: #ffffff !important;
}

.boq-addendum-table .p-datatable-tbody tr td:nth-child(1) { left: 0 !important; width: 80px !important; min-width: 80px !important; }
.boq-addendum-table .p-datatable-tbody tr td:nth-child(2) { left: 80px !important; width: 150px !important; min-width: 150px !important; }
.boq-addendum-table .p-datatable-tbody tr td:nth-child(3) { left: 230px !important; width: 350px !important; min-width: 350px !important; }
.boq-addendum-table .p-datatable-tbody tr td:nth-child(4) {
  left: 580px !important;
  width: 100px !important;
  min-width: 100px !important;
  box-shadow: 3px 0 5px -2px rgba(0,0,0,0.15) !important;
}

/* Non-sticky body columns for addendum - lower z-index */
.boq-addendum-table .p-datatable-tbody tr td:nth-child(n+5) {
  z-index: 1 !important;
}
</style>
